import React from "react";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import {
  AccountReceivableApplicableCreditMemoBean,
  AccountReceivableApplicableInvoiceBean,
  AccountReceivableAppliedCreditMemoLineBean,
  AccountReceivableAutoClearingHouseDetailBean,
  AccountReceivableBean,
  AccountReceivableCardDetailBean,
  AccountReceivableCheckDetailBean,
  AccountReceivableDiscountDetailBean,
  AccountReceivableLineBean,
  AccountReceivablePaymentHistoryPrintRequest,
  AccountReceivablePrintRequest,
  AccountReceivableSearchCriteria,
  AccountReceivableWireTransferDetailBean,
  CustomerBean,
  CustomerSearchCriteria,
  InvoiceSearchCriteria,
  MailInfoBean,
  PageListBean,
  ReasonBean,
  RestAccountReceivableBeanRequest,
  RestAccountReceivableListRequest,
  RestAccountReceivableMailInfoBeanRequest,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  EditableDataGrid_v1,
  InputCheckbox,
  InputTextbox,
  MessageBoxComponent,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
  DatePickerComponent_adv,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toFormattedDate_v1,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import {
  PopupCustomerCurrentAgingInq,
  PopupCustomerMostRecentFabricsInq,
  PopupCustomerOnOrderInq,
  PopupCustomerSalesHistoryInq,
  PopupCustomerStatisticsInq,
  PopupCustomerTransactionsInq,
} from "../Inquiry/InquiryUtil.js";
import { AccountReceivableLookupHandler } from "../lookup/AccountReceivableLookupHandler";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  PopupCreditMemoModule,
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountReceivableService } from "../services/AccountReceivableService";
import { CustomerService } from "../services/CustomerService";
import { ReportService } from "../services/ReportService";
import { ARModuleToolBar } from "../toolBar/ARModuleToolBar.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
class AccountReceivableList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.advanceSearchDialogRef = React.createRef();
    this.state = {
      pageTitle: "Account Receivable",
      accountreceivable_list: new Array(),
      isAccountReceivableListFormOpen: true,
      companyCode: "",
      pageList: new PageListBean(),
      isLoading: false,
      criteria: new AccountReceivableSearchCriteria(),
      isDisableFields: false,
      arData: new AccountReceivableBean(),
      currentPageNumber: 0,
      totalCount: 0,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowPaymentHistoryButton: false,
      isShowMailButton: true,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowReverseButton: false,
      isShowPostButton: true,
      error_list: [],
      isAccountReceivableEntryFormOpen: false,
      customerData: new CustomerBean(),
      isAdvanceSearch: false,
      creditCardTypes: [],
      isCustomerDataLoding: false,
      customer_list: [],
      arLineData: new AccountReceivableLineBean(),
      cardDetail: new AccountReceivableCardDetailBean(),
      checkDetail: new AccountReceivableCheckDetailBean(),
      wireDetail: new AccountReceivableWireTransferDetailBean(),
      achDetail: new AccountReceivableAutoClearingHouseDetailBean(),
      discountDetail: new AccountReceivableDiscountDetailBean(),
      arPaymentTypes: [],
      isCheckPayment: false,
      isCardPayment: false,
      isCashPayment: false,
      isWirePayment: false,
      isAchPayment: false,
      isOtherPayment: false,
      reversalReasons: [],
      cancelReasons: [],
      reasonData: new ReasonBean(),
      isSpecialViewMode: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      isResetView: true,
      isFocusLookup: true,
      isFocus: false,
      selectedNodeKey: "headerView",
      isARHistoryFormOpened: false,
      isShowNodes: false,
      nodeList: [],
      discountReasons: [],
      warningMessage: "",
      isSavedWithWarning: false,
      isShowMailPopup: false,
      mailInfoBean: new MailInfoBean(),
      alertMessage: [],
      isShowAlert: false,
      summaryData: "",
      isMaintenanceMode: true,
      isDisabledFields: false,
      customerPageListForAutoCompleteList: new Array(),
      paymentTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompletePaymentTypeList: true,
      showAutoCompleteList: true,
      isCollapsible_open: true,
      isShowARModule: false,
      isShowInvoiceModule: false,
      isShowDiscountPopup: false,
      isShowCMModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      accountReceivableLookupHandler: null,
      discountReasonLookupHandler: null,
      BillToLookupHandler: null,
      customerLookupHandler: null,
      paymentTypeLookupHandler: null,
      moduleOrderStatus: "",
      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerSalesHistoryInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isCustomerCurrentAgingInq: false,
      isShowLookup: false,
      billTos: [],
      discountList: [],
      isShowDiscountPopup: false,
      isShowPopupAlertlvl1: false,
      showAutoCompleteDiscountList: false,
      discountPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBillToList: false,
      billToPageListForAutoCompleteList: new Array(),
      isShowAdvanceSearchPopup: false,
      isAutoApply: false,
      isAutoCalculate: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlertLvl3: false,
      isShowReversalReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      disableARFormFields: false,
      isShowWarningMsgPopup: false,
      invLines: new Array(),
      crediMemoLines: new Array(),
      disabled: false,
      order: "",
      sortField: "",
      is3PL: false,
      isReseted: false,
      isViewMode: false,
      statusTrackList: [],
      invoiceCriteria: new InvoiceSearchCriteria(),
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    let criteria = new AccountReceivableSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    let currentPage = this.state.pageList.currentPage;
    if (currentPage == null || currentPage <= 0) {
      pageInput.currentPage = 1;
    } else {
      pageInput.currentPage = currentPage;
    }
    this.state.pageList = pageInput;
    this.state.criteria = criteria;
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    ModuleUtils.getARStatusList();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.unlockAccountReceivable(this.props.code);
      this.editAccountReceivable(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        disableARFormFields: true,
      });
    } else {
      this.addNewEntry();
      // this.loadAccountReceivablePage();
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let arPaymentTypes = [];
    arPaymentTypes = this.getARPaymentTypes();
    this.setState({ arPaymentTypes: arPaymentTypes });
    this.state.creditCardTypes = [];
    let creditCardTypes = attribute_cache.creditCardTypes;
    let creditCardTypes_temp = [];
    if (creditCardTypes != null) {
      creditCardTypes.map((ent) => {
        creditCardTypes_temp.push(ent);
        this.state.creditCardTypes =
          ModuleUtils.isActiveAttribute(creditCardTypes_temp);
      });
    }
    this.state.reversalReasons = [];
    let reversalReasons = attribute_cache.accountReceivableReversalReasons;
    let reversalReasons_temp = [];
    if (reversalReasons != null) {
      reversalReasons.map((ent) => {
        reversalReasons_temp.push(ent);
        this.state.reversalReasons =
          ModuleUtils.isActiveAttribute(reversalReasons_temp);
      });
    }
    this.state.discountReasons = [];
    let discountReasons = attribute_cache.extraChargeReasons;
    let discountReasons_temp = [];
    if (discountReasons != null) {
      discountReasons.map((ent) => {
        discountReasons_temp.push(ent);
        this.state.discountReasons =
          ModuleUtils.isActiveAttribute(discountReasons_temp);
      });
    }
    this.getCustomerPageList();
    let currentDate = new Date();
    // this.state.checkDetail.checkDate = currentDate.toLocaleDateString("sv-SE");
    // this.state.wireDetail.wireTransferDate =
    //   currentDate.toLocaleDateString("sv-SE");
    // this.state.achDetail.autoClearingHouseDate =
    //   currentDate.toLocaleDateString("sv-SE");
    setTimeout(() => {
      this.initLookupHandlers();
    }, 100);
  }
  getARPaymentTypes = () => {
    let arPaymentTypes = [];
    let check = new BaseBean();
    check.code = "CHECK";
    check.description = "Check Payment";
    arPaymentTypes.push(check);
    let creditCard = new BaseBean();
    creditCard.code = "CREDITCARD";
    creditCard.description = "CreditCard Payment";
    arPaymentTypes.push(creditCard);
    let debitCard = new BaseBean();
    debitCard.code = "DEBITCARD";
    debitCard.description = "DebitCard Payment";
    arPaymentTypes.push(debitCard);
    let cash = new BaseBean();
    cash.code = "CASH";
    cash.description = "Cash Payment";
    arPaymentTypes.push(cash);
    let wire = new BaseBean();
    wire.code = "WIRE";
    wire.description = "Wire Payment";
    arPaymentTypes.push(wire);
    let ach = new BaseBean();
    ach.code = "ACH";
    ach.description = "Ach Payment";
    arPaymentTypes.push(ach);
    return arPaymentTypes;
  };
  initLookupHandlers = () => {
    let accountReceivableLookupHandler = new AccountReceivableLookupHandler(
      this.companyCode,
      "AccountReceivable",
    );
    this.setState({
      accountReceivableLookupHandler: accountReceivableLookupHandler,
    });
    let discountReasonLookupHandler = new GenericAttributeLookupHandler(
      this.state.discountReasons,
      "Discount Reason",
    );
    this.setState({ discountReasonLookupHandler: discountReasonLookupHandler });
    let paymentTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.arPaymentTypes,
      "Payment Type",
    );
    this.setState({ paymentTypeLookupHandler: paymentTypeLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  getTotalReceivedAmount = () => {
    let totalReceivedAmount = 0;
    totalReceivedAmount =
      parseFloat(this.state.arData.cashAmount) +
      parseFloat(this.state.arData.checkAmount) +
      parseFloat(this.state.arData.cardAmount) +
      parseFloat(this.state.arData.wireTransferAmount) +
      parseFloat(this.state.arData.autoClearingHouseAmount);
    return totalReceivedAmount;
  };
  getTotalCreditMemoAmount = () => {
    let totalCreditMemoAmount = 0;
    if (this.state.arData == null) return 0;
    else if (this.state.arData.lines == null) return 0;
    else if (this.state.arData.lines.length == 0) return 0;
    this.state.arData.lines.map((line) => {
      if (line != null && line.creditMemoFlag) {
        totalCreditMemoAmount =
          parseFloat(totalCreditMemoAmount) +
          parseFloat(line.creditMemoAppliedAmount);
      }
    });
    return totalCreditMemoAmount;
  };
  getTotalInvoiceAppliedAmount = () => {
    let totalInvoiceAppliedAmount = 0;
    if (this.state.arData == null) return 0;
    else if (this.state.arData.lines == null) return 0;
    else if (this.state.arData.lines.length == 0) return 0;
    this.state.arData.lines.map((line) => {
      if (line != null && !line.creditMemoFlag && line.selectedFlag) {
        totalInvoiceAppliedAmount =
          totalInvoiceAppliedAmount + parseFloat(line.totalAppliedAmount);
      }
    });
    return totalInvoiceAppliedAmount;
  };
  pfLineClick = (e, rowData) => {
    let currentLine = rowData;
    let arData = this.state.arData;
    if (arData === null) return;
    if (currentLine != null) {
      if (e.target.value) {
        currentLine.paymentReceivedFlag = true;
        let arData = this.state.arData;
        this.setState({ arData: arData });
        return;
      } else if (!e.target.value) {
        currentLine.paymentReceivedFlag = false;
        let arData = this.state.arData;
        this.setState({ arData: arData });
        return;
      }
    }
  };
  invoiceLineSelected = (eve, rowData) => {
    let currentLine = rowData;
    let arData = this.state.arData;
    if (arData === null) return;
    if (arData.accountReceivableStatus !== "O") return;
    if (currentLine != null) {
      if (!eve.target.value) {
        // if (currentLine.paymentReceivedFlag) {
        if (currentLine.isPaymentReceivedFlag) {
          currentLine.selectedFlag = true;
          let arData = this.state.arData;
          this.setState({ arData: arData, isAutoApply: false });
          return;
        }
        currentLine.creditMemoAppliedAmount = 0;
        currentLine.totalAppliedAmount = 0;
        currentLine.appliedAmount = 0;
        // currentLine.selectedFlag = false;
        // let arData = this.state.arData;
        arData.lines.map((ln) => {
          if (ln.invoiceNumber == rowData.invoiceNumber) {
            ln.selectedFlag = false;
            ln.creditMemoAppliedAmount = 0;
            ln.totalAppliedAmount = 0;
            ln.appliedAmount = 0;
          }
        });
        // this.setState({ arData: arData });
        // this.setState({ arData: arData });
      }
      let totReceivedAmount = parseFloat(this.getTotalReceivedAmount()).toFixed(
        2,
      );
      let totCreditMemoAmount = parseFloat(
        this.getTotalCreditMemoAmount(),
      ).toFixed(2);
      let totInvoiceAppliedAmount = parseFloat(
        this.getTotalInvoiceAppliedAmount(),
      ).toFixed(2);
      let discountAmount = parseFloat(this.state.arData.discountAmount).toFixed(
        2,
      );

      if (eve.target.value) {
        let invNumber = currentLine.invoiceNumber;
        // if (currentLine.paymentReceivedFlag) {
        if (currentLine.isPaymentReceivedFlag) {
          if (currentLine.openInvoiceAmount == currentLine.totalAppliedAmount) {
            return;
          } else if (currentLine.totalAppliedAmount > 0) {
            return;
          }
        }

        let openAmount =
          parseFloat(totReceivedAmount) -
          parseFloat(totCreditMemoAmount) -
          parseFloat(totInvoiceAppliedAmount) +
          parseFloat(discountAmount);

        if (openAmount > currentLine.openInvoiceAmount) {
          currentLine.totalAppliedAmount = currentLine.openInvoiceAmount;
          currentLine.appliedAmount = currentLine.openInvoiceAmount;
        } else {
          let appliedAmount =
            openAmount > 0
              ? openAmount
              : totReceivedAmount > 0
                ? 0
                : currentLine.openInvoiceAmount;
          currentLine.appliedAmount = appliedAmount;
          currentLine.totalAppliedAmount = appliedAmount;
        }
      }
      // let arData = this.state.arData;
      this.setState({ arData: arData, isAutoApply: false });
    }
  };
  creditMemoLineSelected = (eve, rowData) => {
    let currentLine = rowData;
    let arData = this.state.arData;
    if (arData === null) return;
    if (arData.accountReceivableStatus !== "O") return;
    let temp_AppliedAmt = 0;
    if (currentLine.creditMemoFlag) {
      temp_AppliedAmt = currentLine.CreditMemoAppliedAmount;
    } else {
      temp_AppliedAmt = currentLine.totalAppliedAmount;
    }
    let tenAmount =
      this.state.arData.cardAmount +
      this.state.arData.discountAmount +
      this.state.arData.cashAmount +
      this.state.arData.checkAmount +
      this.state.arData.wireTransferAmount +
      this.state.arData.autoClearingHouseAmount;
    let totalReceivedAmount_Calc =
      arData.cashAmount +
      arData.checkAmount +
      arData.cardAmount +
      arData.wireTransferAmount +
      arData.autoClearingHouseAmount;
    if (currentLine != null) {
      if (!eve.target.value) {
        if (currentLine.paymentReceivedFlag) {
          currentLine.selectedFlag = true;
          let arData = this.state.arData;
          this.setState({ arData: arData, isAutoApply: false });
          return;
        }
        currentLine.creditMemoAppliedAmount = 0;
        currentLine.totalAppliedAmount = 0;
        currentLine.appliedAmount = 0;
      } else if (eve.target.value) {
        if (currentLine.creditMemoFlag) {
          let cmNumber = currentLine.invoiceNumber;
          if (tenAmount > currentLine.creditMemoAppliedAmount) {
            currentLine.creditMemoAppliedAmount = currentLine.openInvoiceAmount;
          } else {
            currentLine.creditMemoAppliedAmount = currentLine.openInvoiceAmount;
          }
          this.state.arData.applicableCreditMemos.map((cm) => {
            if (cmNumber == cm.invoiceNumber) {
              cm.applicableAmount = currentLine.creditMemoAppliedAmount;
            }
          });
        }
        if (currentLine.paymentReceivedFlag) {
          if (currentLine.openInvoiceAmount === temp_AppliedAmt) return 0;
          if (temp_AppliedAmt > 0) return 0;
        }
        if (this.OpenAmount_Calc > currentLine.openInvoiceAmount) {
          currentLine.TotalAppliedAmount = currentLine.OpenInvoiceAmount;
        } else {
          currentLine.TotalAppliedAmount =
            this.OpenAmount_Calc > 0
              ? this.OpenAmount_Calc
              : totalReceivedAmount_Calc > 0
                ? 0
                : currentLine.OpenInvoiceAmount;
        }
        this.state.arData.applicableCreditMemos.map((cm) => {
          if (currentLine.invoiceNumber == cm.invoiceNumber) {
            cm.applicableAmount = currentLine.OpenInvoiceAmount;
          }
        });
      }
      this.setState({ arData: arData, isAutoApply: false });
    }
  };
  resetAppliedAmountClick = (eve) => {
    const arData = { ...this.state.arData };

    arData.cashAmount = 0;

    arData.WireNumber = 0;
    arData.wireTransferAmount = 0;
    arData.wireTransferDetailLines = new Array();

    arData.cardNumber = 0;
    arData.cardAmount = 0;
    arData.cardDetailLines = new Array();

    arData.checkNumber = 0;
    arData.checkAmount = 0;
    arData.checkDetailLines = new Array();

    arData.achNumber = 0;
    arData.autoClearingHouseAmount = 0;
    arData.autoClearingHouseDetailLines = new Array();

    arData.discountAmount = 0;

    arData.totalReceivedAmount = 0;

    // arData.cardAmount = 0;
    // arData.cashAmount = 0;
    // arData.checkAmount = 0;
    // arData.wireTransferAmount = 0;
    // arData.autoClearingHouseAmount = 0;
    if (this.state.wireDetail != null)
      this.state.wireDetail.wireTransferAmount = 0;
    if (this.state.checkDetail != null) this.state.checkDetail.checkAmount = 0;
    if (this.state.cardDetail != null) this.state.cardDetail.cardAmount = 0;
    if (this.state.achDetail != null)
      this.state.achDetail.autoClearingHouseAmount = 0;
    if (arData != null) {
      if (arData.lines != null) {
        arData.lines.map((ln) => {
          ln.appliedAmount = 0;
          ln.creditMemoAppliedAmount = 0;
          ln.totalAppliedAmount = 0;
          ln.selectedFlag = false;
        });
      }
    }
    this.setState({
      arData: arData,
      isAutoCalculate: false,
      isAutoApply: false,
    });
  };
  autoApplyClick = (e) => {
    this.state.isAutoApply = true;
    let arData = this.state.arData;
    const cmLines = arData.lines.filter((ln) => ln.creditMemoFlag === true);
    if (arData == null) {
      let errMsg = "arData is Null";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      return 0;
    } else if (isEmptyArray(arData.lines)) {
      let errMsg = "No Ar Lines To Apply";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      return 0;
    } else if (cmLines === null && cmLines === undefined) {
      let errMsg = "No Open Amount To Apply";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      return 0;
    }
    arData.lines.map((line) => {
      if (line != null && line.creditMemoFlag) {
        line.creditMemoAppliedAmount = 0;
        line.totalAppliedAmount = 0;
        line.creditMemoAppliedAmount = line.openInvoiceAmount;
      } else if (line != null && !line.creditMemoFlag) {
        line.appliedAmount = 0;
        line.totalAppliedAmount = 0;
      }
    });

    if (this.OpenAmount_Calc() > 0) {
      this.hideAlertCallBack();
      this.autoApply(arData);
      setTimeout(() => {
        arData.lines.map((line) => {
          if (line != null) {
            if (
              line.totalAppliedAmount != 0 ||
              line.creditMemoAppliedAmount != 0
            ) {
              line.selectedFlag = true;
            } else {
              line.selectedFlag = false;
            }
          }
        });
      }, 200);
    } else {
      let errMsg = "No Open Amount To Apply";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    setTimeout(() => {
      this.setState({ arData: arData });
    }, 300);

    // } else {

    // }
  };
  OpenAmount_Calc = () => {
    let receivedAmt = this.getTotalReceivedAmount().toFixed(2);
    let creditAmt = this.getTotalCreditMemoAmount().toFixed(2);
    let TotalAppliedAmt = this.getTotalAppliedAmount().toFixed(2);
    let openAmt =
      receivedAmt -
      creditAmt -
      TotalAppliedAmt +
      parseFloat(this.state.arData.discountAmount);
    openAmt = openAmt.toFixed(2);
    return openAmt;
  };
  inCompleteInvoiceAppliedAmount = () => {
    let arData = this.state.arData;
    let isFound = false;
    if (arData.lines != null) {
      arData.lines.map((line) => {
        if (
          !line.creditMemoFlag &&
          line.openInvoiceAmount > line.totalAppliedAmount
        ) {
          isFound = true;
          return isFound;
        } else {
          isFound = false;
        }
      });
    } else {
      return isFound;
    }
  };
  totalAppliedAmount_Calc = (ln) => {
    let remAmt =
      parseFloat(ln.appliedAmount) +
      parseFloat(ln.chargeBackAppliedAmount) +
      parseFloat(ln.creditMemoAppliedAmount);
    return remAmt;
  };
  isFullyPaid = (ln) => {
    let remAmt =
      parseFloat(ln.openInvoiceAmount) - this.totalAppliedAmount_Calc(ln);
    if (remAmt == 0) {
      return true;
    }
    return false;
  };
  autoApply = (arData) => {
    let remainingTenderAmount = this.getTotalReceivedAmount();
    let remainingCreditAmount = this.getTotalCreditMemoAmount() * -1;
    arData.lines.map((line) => {
      if (remainingTenderAmount == 0 && remainingCreditAmount == 0) return 0;
      if (!this.isFullyPaid(line)) {
        let lineOpenAmount =
          line.openInvoiceAmount - this.totalAppliedAmount_Calc(line);
        let isApplied = false;
        if (lineOpenAmount >= remainingTenderAmount) {
          isApplied = true;
          if (!line.creditMemoFlag) line.appliedAmount += remainingTenderAmount;
          remainingTenderAmount = 0;
          let openAmount =
            line.openInvoiceAmount - this.totalAppliedAmount_Calc(line);
        } else if (remainingTenderAmount > lineOpenAmount) {
          isApplied = true;
          if (!line.creditMemoFlag) line.appliedAmount += lineOpenAmount;
          remainingTenderAmount -= line.appliedAmount;
        }
        if (isApplied) {
          line.totalAppliedAmount = this.totalAppliedAmount_Calc(line);
        }
      }
    });

    let totalCreditAmount = this.getTotalCreditMemoAmount();
    let calibratedRemainingAmount = -(
      remainingCreditAmount + totalCreditAmount
    );
    // from arData
    arData.lines.map((line) => {
      if (line.creditMemoFlag) {
        line.totalAppliedAmount = 0;
        if (calibratedRemainingAmount > 0) {
          if (calibratedRemainingAmount > -line.openInvoiceAmount) {
            line.creditMemoAppliedAmount = line.openInvoiceAmount;
            calibratedRemainingAmount += line.creditMemoAppliedAmount;
          } else {
            line.creditMemoAppliedAmount = -calibratedRemainingAmount;
            calibratedRemainingAmount = 0;
          }
        }
      }
    });
    // from Local cmLines
    // const crediMemoLines = this.state.crediMemoLines;
    // if(!isEmptyArray(crediMemoLines)){
    //   crediMemoLines.map((line) => {
    //     if (line.creditMemoFlag) {
    //       line.totalAppliedAmount = 0;
    //       if (calibratedRemainingAmount > 0) {
    //         if (calibratedRemainingAmount > -line.openInvoiceAmount) {
    //           line.creditMemoAppliedAmount = line.openInvoiceAmount;
    //           calibratedRemainingAmount += line.creditMemoAppliedAmount;
    //         } else {
    //           line.creditMemoAppliedAmount = -calibratedRemainingAmount;
    //           calibratedRemainingAmount = 0;
    //         }
    //       }
    //     }
    //   });
    // }
  };
  setTotalCreditMemoAmount = (arData) => {
    if (arData == null) return 0;
    else if (arData.lines == null) return 0;
    else if (arData.lines.length == 0) return 0;
    arData.lines.map((line) => {
      if (line != null && line.creditMemoFlag) {
        line.creditMemoAppliedAmount = 0;
        line.totalAppliedAmount = 0;
      }
    });
  };
  autoCalculateClick = (e) => {
    const arData = { ...this.state.arData };
    this.state.isAutoCalculate = true;
    this.setAppliedAmt(arData);
    if (this.state.arData.paymentTypeCode == "CASH") {
      arData.cashAmount = arData.remainingApplicableAmount;
    } else if (
      this.state.arData.paymentTypeCode == "CREDITCARD" ||
      this.state.arData.paymentTypeCode == "DEBITCARD"
    ) {
      arData.cardAmount = arData.remainingApplicableAmount;
      this.state.cardDetail.cardAmount = arData.remainingApplicableAmount;
    } else if (this.state.arData.paymentTypeCode == "CHECK") {
      arData.checkAmount = arData.remainingApplicableAmount;
      this.state.checkDetail.checkAmount = arData.remainingApplicableAmount;
    } else if (this.state.arData.paymentTypeCode == "WIRE") {
      arData.wireTransferAmount = arData.remainingApplicableAmount;
      this.state.wireDetail.wireTransferAmount =
        arData.remainingApplicableAmount;
    } else if (this.state.arData.paymentTypeCode == "ACH") {
      arData.autoClearingHouseAmount = arData.remainingApplicableAmount;
      this.state.achDetail.autoClearingHouseAmount =
        arData.remainingApplicableAmount;
    }
    arData.lines.map((line) => {
      if (line != null) {
        if (line.totalAppliedAmount != 0 || line.creditMemoAppliedAmount != 0) {
          line.selectedFlag = true;
        } else {
          line.selectedFlag = false;
        }
      }
    });
    this.setState({ arData: arData });
  };
  setAppliedAmt = (arData) => {
    this.state.checkDetail.checkAmount = 0;
    this.state.cardDetail.cardAmount = 0;
    this.state.arData.cashAmount = 0;
    this.state.wireDetail.wireTransferAmount = 0;
    this.state.achDetail.autoClearingHouseAmount = 0;
    this.resetARLinesAppliedChanges(arData);
    let remainingApplicableAmount = 0;
    arData.lines.map((ln) => {
      remainingApplicableAmount += ln.openInvoiceAmount - ln.appliedAmount;
    });
    arData.remainingApplicableAmount = remainingApplicableAmount;
    arData.lines.map((ln) => {
      if (!ln.creditMemoFlag) {
        ln.appliedAmount = ln.openInvoiceAmount;
        ln.totalAppliedAmount = ln.openInvoiceAmount;
      } else {
        ln.creditMemoAppliedAmount = ln.openInvoiceAmount;
        ln.totalAppliedAmount = ln.openInvoiceAmount;
      }
    });
    setTimeout(() => {
      this.autoApply(arData);
    }, 100);
  };
  resetARLinesAppliedChanges = (arData) => {
    arData.lines.map((ln) => {
      ln.appliedAmount = 0;
      ln.creditMemoAppliedAmount = 0;
      ln.totalAppliedAmount = 0;
    });
  };
  onAppliedAmountChange = (e, rowData) => {
    // const _arData = { ...this.state.arData };
    // const data = { ...rowData };
    // let ar_Lines = [];
    // if (e.target.name == "totalAppliedAmount") {
    //   if (!this.isCalculateandValidateAppliedAmount(e.target.value, data)) {
    //     rowData[e.target.name] = 0;
    //   } else {
    //     _arData.lines.map((ln) => {
    //       if (ln.invoiceNumber === data.invoiceNumber) {
    //         ln[e.target.name] = e.target.value;
    //         ln.selectedFlag = true;
    //       }
    //       ar_Lines.push(ln);
    //       _arData.lines = ar_Lines;
    //     });
    //     this.state.arData = _arData;
    //   }
    // } else if (e.target.name == "creditMemoAppliedAmount") {
    //   if (!this.isCalculateandValidateCmAppliedAmount(e.target.value, data)) {
    //     data[e.target.name] = 0;
    //     // rowData[e.target.name] = -e.target.value;
    //   } else {
    //     _arData.lines.map((ln) => {
    //       if (
    //         ln.invoiceNumber === data.invoiceNumber &&
    //         ln.creditMemoFlag === true
    //       ) {
    //         ln[e.target.name] = -e.target.value;
    //         ln.selectedFlag = true;
    //       }
    //       ar_Lines.push(ln);
    //       _arData.lines = ar_Lines;
    //     });
    //     this.state.arData = _arData;
    //   }
    // }
    // this.state.arData = arData;
  };

  isCalculateandValidateAppliedAmount = (currentAppliedAmount, rowData) => {
    let isvalid = true;
    const data = { ...rowData };
    if (parseFloat(currentAppliedAmount) > parseFloat(data.openInvoiceAmount)) {
      isvalid = false;
    }
    return isvalid;
  };
  getTotalAppliedAmount() {
    let totalAppliedAmount = 0;
    this.state.arData.lines.map((arLine) => {
      if (arLine.selectedFlag || !arLine.creditMemoFlag) {
        let appliedAmt = parseFloat(arLine.totalAppliedAmount);
        totalAppliedAmount = parseFloat(totalAppliedAmount) + appliedAmt;
      }
    });
    return totalAppliedAmount;
  }
  isCalculateandValidateCmAppliedAmount = (currentAppliedAmount, rowData) => {
    let isvalid = true;
    let totReceivedAmount = -parseFloat(rowData.openInvoiceAmount);
    if (parseFloat(currentAppliedAmount) > parseFloat(totReceivedAmount)) {
      isvalid = false;
    }
    return isvalid;
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.reversalReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.reversalReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.reversalReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowReversalReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowReversalReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };

  reverseReasonContinue = () => {
    this.saveReverseAccountReceivable();
    this.closeReasonModelCallBack();
  };

  getCustomerPageListResponse = (response) => {
    let customer_list = [];
    if (response.data.customerPageList != null) {
      customer_list = response.data.customerPageList.customers;
    }
    this.setState({
      customer_list: customer_list,
      isCustomerDataLoding: false,
    });
  };
  getCustomerPageListError = (error) => {
    ShowError("Error : " + error);
  };
  getCustomerPageList = () => {
    this.setState({ isCustomerDataLoding: true });
    let cust_criteria = new CustomerSearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    if (SecurityAccessManager.AccountReceivableMaintenance_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.getCustomerPageListResponse,
        this.getCustomerPageListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getCriteriaString = () => {
    let criteriaString = "";
    if (this.state.criteria == null) {
      return <div />;
    } else {
      if (!isEmptyString(this.state.criteria.accountReceivableNumber))
        criteriaString =
          criteriaString +
          "AR# : " +
          this.state.criteria.accountReceivableNumber +
          " ; ";
      if (!isEmptyString(this.state.criteria.accountReceivableNumberStartsWith))
        criteriaString =
          criteriaString +
          "AR# StartsWith : " +
          this.state.criteria.accountReceivableNumberStartsWith +
          " ; ";
      if (!isEmptyString(this.state.criteria.accountReceivableNumberContains))
        criteriaString =
          criteriaString +
          "AR# Contains : " +
          this.state.criteria.accountReceivableNumberContains +
          " ; ";
      if (!isEmptyString(this.state.criteria.checkNumber))
        criteriaString =
          criteriaString +
          "Check# : " +
          this.state.criteria.checkNumber +
          " ; ";
      if (!isEmptyString(this.state.criteria.customerCode))
        criteriaString =
          criteriaString +
          "Customer# : " +
          this.state.criteria.customerCode +
          " ; ";
    }
    return <div>{criteriaString}</div>;
  };
  arOnChange = (e) => {
    let temp_arData = this.state.arData;
    temp_arData[e.target.name] = e.target.value;
    this.setState({ arData: temp_arData });
  };
  checkDetailsOnChange = (e) => {
    let temp_checkDetail = this.state.checkDetail;
    temp_checkDetail[e.target.name] = e.target.value;
    if (e.target.name == "checkAmount") {
      let temp_arData = this.state.arData;
      temp_arData.checkAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
    this.setState({
      checkDetail: temp_checkDetail,
    });
  };
  wireDetailsOnChange = (e) => {
    let temp_wireDetail = this.state.wireDetail;
    temp_wireDetail[e.target.name] = e.target.value;
    if (e.target.name == "wireTransferAmount") {
      let temp_arData = this.state.arData;
      temp_arData.wireTransferAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
    this.setState({
      wireDetail: temp_wireDetail,
    });
  };
  achDetailsOnChange = (e) => {
    let temp_achDetail = this.state.achDetail;
    temp_achDetail[e.target.name] = e.target.value;
    if (e.target.name == "autoClearingHouseAmount") {
      let temp_arData = this.state.arData;
      temp_arData.autoClearingHouseAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
    this.setState({
      achDetail: temp_achDetail,
    });
  };
  cardDetailsOnChange = (e) => {
    let temp_cardDetail = this.state.cardDetail;
    temp_cardDetail[e.target.name] = e.target.value; // e.target.type =="text"
    if (e.target.name == "cardAmount") {
      let temp_arData = this.state.arData;
      temp_arData.cardAmount = e.target.value;
      this.setState({ arData: temp_arData });
    }
    if (e.target.name == "cardNumber") {
      let temp_arData = this.state.arData;
      temp_arData.cardNumber = e.target.value;
      this.setState({ arData: temp_arData });
    }
    // console.log("arData..", this.state.arData);
    this.setState({
      cardDetail: temp_cardDetail,
    });
  };
  isValidatetoPay = () => {
    let isValid = true;
    let err_list = [];
    let arData = this.state.arData;
    let count = 0;
    if (arData.lines != null) {
      arData.lines.map((ent) => {
        ++count;
      });
    }
    let totalReceivedAmount_Calc =
      arData.cashAmount +
      arData.checkAmount +
      arData.cardAmount +
      arData.wireTransferAmount +
      arData.autoClearingHouseAmount;
    if (totalReceivedAmount_Calc > 0 && count > 0) {
      if (arData.paymentTypeCode == "Check") {
        if (isEmptyString(this.state.checkDetail.checkNumber)) {
          let errMsg = "Check Number Not Entered - Enter the Check Number";
          err_list.push(errMsg);
        }
        if (this.state.checkDetail.checkDate != null) {
          let errMsg = "CheckDate Not Entered - Enter the Check Date";
          err_list.push(errMsg);
        }
        if (this.state.checkDetail.checkAmount == 0) {
          let errMsg = "CheckAmount Not Entered - Enter the CheckAmount";
          err_list.push(errMsg);
        }
      }
      if (arData.paymentTypeCode == "WireTransfer") {
        if (isEmptyString(this.state.wireDetail.wireTransferReferenceNumber)) {
          let errMsg = "WireRefNo Not Entered - Enter the WireReferenceNumber";
          err_list.push(errMsg);
        }
        if (this.state.wireDetail.wireTransferDate != null) {
          let errMsg =
            "WireTransferDate Not Entered - Enter the WireTransfer Date";
          err_list.push(errMsg);
        }
        if (this.state.wireDetail.wireTransferAmount == 0) {
          let errMsg = "Amount Not Entered - Enter the Amount";
          err_list.push(errMsg);
        }
      }
      if (arData.paymentTypeCode == "ACH") {
        if (
          isEmptyString(this.state.achDetail.autoClearingHouseReferenceNumber)
        ) {
          let errMsg = "ACH Ref# Not Entered - Enter the ACHReferenceNumber";
          err_list.push(errMsg);
        }
        if (this.state.achDetail.autoClearingHouseDate == null) {
          let errMsg = "ACHDate Not Entered - Enter the ACH Date";
          err_list.push(errMsg);
        }
        if (this.state.achDetail.autoClearingHouseAmount == 0) {
          let errMsg = "Amount Not Entered - Enter the Amount";
          err_list.push(errMsg);
        }
      }
      if (
        arData.paymentTypeCode == "CreditCard" ||
        arData.paymentTypeCode == "DebitCard"
      ) {
        if (isEmptyString(this.state.cardDetail.cardNumber)) {
          let errMsg = "CardNumber Not Entered - Enter the CardNumber";
          err_list.push(errMsg);
        }
        if (isEmptyString(this.state.cardDetail.cardType)) {
          let errMsg = "CardType Not Entered - Enter the CardType";
          err_list.push(errMsg);
        }
        if (isEmptyString(this.state.cardDetail.expiryMonth)) {
          let errMsg = "ExpiryMonth Not Entered - Enter the ExpiryMonth";
          err_list.push(errMsg);
        }
        if (isEmptyString(this.state.cardDetail.expiryYear)) {
          let errMsg = "ExpiryYear Not Entered - Enter the ExpiryYear";
          err_list.push(errMsg);
        }
        if (this.state.cardDetail.cardAmount == 0) {
          let errMsg = "Amount Not Entered - Enter the Amount";
          err_list.push(errMsg);
        }
      }
    }
    if (count <= 0) {
      let errMsg = "No Selected Invoice/Credit Line Desc";
      err_list.push(errMsg);
    }
    this.setState({ error_list: err_list });
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
      isValid = false;
    }
    return isValid;
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.arData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.arData;
      tempData.customerCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        arData: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
      this.customerCleared();
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ arData: tempData });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerByCustomerCode(customerCode);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.readItemByCustomerCodeError,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readItemByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  readCustomerByCustomerCodeResponse = (response) => {
    let customerData = response.data.customer;
    if (customerData != null) {
      let summary = customerData.accountSummary;
      this.setState(
        { customerData: customerData, summaryData: summary },
        () => {
          this.setDefaultValues(customerData);
        },
      );
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readCustomerByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "loading Customer",
    });
    if (SecurityAccessManager.AccountReceivableMaintenance_IsAccessible()) {
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerByCustomerCodeResponse,
        this.readCustomerByCustomerCodeError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  customerCleared() {
    let arData = this.state.arData;
    arData.customerName = "";
    arData.customerCurrencyCode = "";
    arData.billToCode = "";
    arData.paymentTypeCode = "CHECK";
    arData.lines = new Array();
    arData.applicableInvoices = new Array();
    arData.applicableCreditMemos = new Array();
    this.state.arData = arData;
    console.log("arData...", arData);
    this.setState({
      arData: arData,
      invLines: new Array(),
      crediMemoLines: new Array(),
      isCheckPayment: true,
      isCardPayment: false,
      isWirePayment: false,
      isAchPayment: false,
      isOtherPayment: false,
      isCashPayment: false,
      cardDetail: new AccountReceivableCardDetailBean(),
      checkDetail: new AccountReceivableCheckDetailBean(),
      wireDetail: new AccountReceivableWireTransferDetailBean(),
      achDetail: new AccountReceivableAutoClearingHouseDetailBean(),
    });
  }
  setDefaultValues = (customerData) => {
    let arData = this.state.arData;
    arData.customerCode = customerData.code;
    arData.customerName = customerData.description;
    if (!isEmpty(customerData.billTos)) {
      let BillToLookupHandler = new GenericAttributeLookupHandler(
        customerData.billTos,
        "Bill To",
      );
      this.setState({
        BillToLookupHandler: BillToLookupHandler,
        isShowLookup: true,
        billTos: customerData.billTos,
      });
      arData.billToCode = customerData.billTos[0].code;
    } else {
      arData.billToCode = "B1001";
      this.setState({
        isShowLookup: false,
      });
    }
    arData.customerCurrencyCode = customerData.currencyCode;
    arData.companyCurrencyCode = arData.customerCurrencyCode;
    arData.applicableInvoices = new Array();
    arData.applicableCreditMemos = new Array();
    this.setState({
      arData: arData,
      crediMemoLines: new Array(),
      invLines: new Array(),
    });
    this.readAccountReceivableDependenciesOfCustomer();
  };
  readAccountReceivableDependenciesOfCustomerResponse = (response) => {
    if (
      response != null &&
      response.data != null &&
      !isEmpty(response.data.openInvoicesResponse) &&
      !isEmpty(response.data.openInvoicesResponse.invoicePageList) &&
      !isEmptyArray(response.data.openInvoicesResponse.invoicePageList.invoices)
    ) {
      const openInvoices =
        response.data.openInvoicesResponse.invoicePageList.invoices;
      // console.log("open invoices :##", openInvoices);
      if (openInvoices != null && openInvoices.length > 0) {
        let arData = this.state.arData;
        arData.lines = [];
        arData.applicableInvoices = [];
        openInvoices.map((inv) => {
          let arLine = new AccountReceivableLineBean();
          arLine.companyCode = inv.companyCode;
          arLine.customerCode = arData.customerCode;
          arLine.accountReceivableNumber = arData.code;
          arLine.invoiceNumber = inv.code;
          arLine.invoiceDate = inv.invoiceDate;
          arLine.currencyCode = inv.invoiceCurrencyCode;
          arLine.currencyExchangeRate = 1;
          arLine.totalAppliedAmount = 0;
          arLine.customerPurchaseOrderNumber = inv.customerPurchaseOrderNumber;
          let grantTotalAmount = parseFloat(inv.grandTotalAmount).toFixed(2);
          let postedPaidAmount = parseFloat(inv.netPaidAmount).toFixed(2);
          let unPostedPaidAmount =
            inv.provisionalChargeBackAmount +
            inv.provisionalOtherAppliedAmount +
            inv.provisionalCreditMemoAmount;
          unPostedPaidAmount = parseFloat(unPostedPaidAmount).toFixed(2);
          arLine.postedPaidAmount = postedPaidAmount;
          arLine.unPostedPaidAmount = unPostedPaidAmount;
          arLine.grantTotalAmount = grantTotalAmount;

          arLine.openInvoiceAmount =
            inv.grandTotalAmount -
            (inv.netPaidAmount +
              inv.provisionalChargeBackAmount +
              inv.provisionalOtherAppliedAmount +
              inv.provisionalCreditMemoAmount);
          // console.log("arLine grantTotalAmount", arLine.grantTotalAmount);

          // console.log("arLine openInvoiceAmount", arLine.openInvoiceAmount);
          if (
            isEmptyString(arLine.openInvoiceAmount) ||
            arLine.openInvoiceAmount == NaN
          )
            arLine.openInvoiceAmount = 0;
          arLine.openInvoiceAmount = parseFloat(
            arLine.openInvoiceAmount,
          ).toFixed(2);
          arLine.appliedAmount = 0;
          arLine.invoiceDate = inv.invoiceDate;
          arLine.customerPurchaseOrderNumber = inv.customerPurchaseOrderNumber;
          arLine.creditMemoFlag = false;
          arData.lines.push(arLine);
          let invLine = new AccountReceivableApplicableInvoiceBean();
          invLine.companyCode = this.companyCode;
          invLine.invoiceNumber = inv.code;
          invLine.accountReceivableNumber = arData.code;
          invLine.invoiceCreatedDate = inv.createdDate;
          invLine.currencyCode = inv.companyCurrencyCode;
          invLine.invoiceGrandTotalAmount = inv.grandTotalAmount;
          invLine.invoicePaidAmount = inv.netPaidAmount;
          invLine.invoiceProvisionalPaymentAmount =
            inv.provisionalPaymentAmount;
          invLine.applicableAmount = arLine.openInvoiceAmount;
          arData.applicableInvoices.push(invLine);
        });
        let invoiceLines = new Array();
        arData.lines.map((ln) => {
          if (!ln.creditMemoFlag) {
            invoiceLines.push(ln);
          }
        });
        this.setState({ arData: arData, invLines: invoiceLines });
      }
    }
    if (
      !isEmpty(response.data.openCreditMemosResponse) &&
      !isEmpty(response.data.openCreditMemosResponse.creditMemoPageList) &&
      !isEmptyArray(
        response.data.openCreditMemosResponse.creditMemoPageList.creditMemos,
      )
    ) {
      let openCreditMemos =
        response.data.openCreditMemosResponse.creditMemoPageList.creditMemos;
      if (openCreditMemos != null && openCreditMemos.length > 0) {
        let arData = this.state.arData;
        openCreditMemos.map((creditMemo) => {
          let arLine = new AccountReceivableLineBean();
          arLine.companyCode = creditMemo.companyCode;
          arLine.accountReceivableNumber = arData.code;
          arLine.invoiceNumber = creditMemo.code;
          arLine.currencyCode = creditMemo.invoiceCurrencyCode;
          arLine.grantTotalAmount = -creditMemo.totalCreditAmount;
          arLine.totalAppliedAmount = 0;
          arLine.creditMemoAppliedAmount = 0;
          arLine.postedPaidAmount = -creditMemo.appliedAmount;
          arLine.unPostedPaidAmount = -creditMemo.provisionalAppliedAmount;
          let invoiceAmt =
            arLine.grantTotalAmount +
            parseFloat(
              creditMemo.appliedAmount + creditMemo.provisionalAppliedAmount,
            );
          arLine.openInvoiceAmount = invoiceAmt.toFixed(2);
          arLine.invoiceDate = creditMemo.createdDate;
          let remarks = "";
          if (!isEmptyString(creditMemo.creditType)) {
            if (
              !isEmptyString(creditMemo.createdSourceType) &&
              !isEmptyString(creditMemo.createdSourceEntityNumber)
            ) {
              remarks =
                creditMemo.creditType +
                "," +
                creditMemo.createdSourceType +
                ":" +
                creditMemo.createdSourceEntityNumber;
            } else {
              remarks = creditMemo.creditType;
            }
          }
          arLine.customerPurchaseOrderNumber = remarks;
          arLine.creditMemoFlag = true;
          let existingLine = null;
          arData.lines.map((line) => {
            if (
              line.invoiceNumber === arLine.invoiceNumber &&
              line.creditMemoFlag
            ) {
              existingLine = line;
            }
          });
          if (existingLine === null && arLine.openInvoiceAmount < 0) {
            arData.lines.push(arLine);
          }
          let creditMemoLine = new AccountReceivableApplicableCreditMemoBean();
          creditMemoLine.companyCode = this.companyCode;
          creditMemoLine.creditMemoNumber = creditMemo.code;
          creditMemoLine.currencyCode = creditMemo.customerCurrencyCode;
          creditMemoLine.creditmemoCreatedDate = creditMemo.createdDate;
          creditMemoLine.creditMemoAmount = creditMemo.totalCreditAmount;
          creditMemoLine.creditMemoAppliedAmount = creditMemo.appliedAmount;
          creditMemoLine.creditMemoProvisionalAppliedAmount =
            creditMemo.provisionalAppliedAmount;
          creditMemoLine.applicableAmount =
            parseFloat(creditMemoLine.creditMemoAmount) -
            parseFloat(creditMemoLine.creditMemoAppliedAmount);
          let existingCMLine = null;
          existingCMLine = this.getCMLine(
            arData.applicableCreditMemos,
            creditMemoLine.creditMemoNumber,
          );
          if (existingCMLine === null && creditMemoLine.applicableAmount > 0)
            arData.applicableCreditMemos.push(creditMemoLine);
        });
        let creditMemoLines = new Array();
        arData.lines.map((ln) => {
          if (ln.creditMemoFlag) {
            creditMemoLines.push(ln);
          }
        });
        this.setState({ arData: arData, crediMemoLines: creditMemoLines });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readAccountReceivableDependenciesOfCustomerError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  readAccountReceivableDependenciesOfCustomer = () => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    let customerData = this.state.customerData;
    readrestInput.code = customerData.code;

    if (SecurityAccessManager.AccountReceivableMaintenance_IsAccessible()) {
      AccountReceivableService.readAccountReceivableDependenciesOfCustomer(
        readrestInput,
        this.readAccountReceivableDependenciesOfCustomerResponse,
        this.readAccountReceivableDependenciesOfCustomerError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getCMLine = (lines, creditMemoNumber) => {
    let cmLine = null;
    if (
      !isEmptyString(creditMemoNumber) &&
      lines !== null &&
      lines.length > 0
    ) {
      lines.map((line) => {
        if (line.creditMemoNumber === creditMemoNumber) {
          cmLine = line;
          return cmLine;
        }
      });
    }
    return cmLine;
  };
  loadAccountReceivablePageResponse = (response) => {
    let accountreceivable_list = new Array();
    let pageList = this.state.pageList;
    if (response.data.accountReceivablePageList != null) {
      accountreceivable_list =
        response.data.accountReceivablePageList.accountReceivables;
      pageList.totalCount = response.data.accountReceivablePageList.totalCount;
      pageList.currentPage =
        response.data.accountReceivablePageList.currentPage;
    } else {
      accountreceivable_list = new Array();
    }
    let loading = false;
    this.setState({
      isLoading: loading,
      accountreceivable_list: accountreceivable_list,
      pageList: pageList,
    });
  };
  loadAccountReceivablePageError = (error) => {
    ShowError("Error : " + error);
  };
  loadAccountReceivablePage = () => {
    let loading = this.state.isLoading;
    loading = true;
    this.setState({ isLoading: loading, loadingText: "Loading..." });
    let criteria = new AccountReceivableSearchCriteria();
    criteria = this.state.criteria;
    let pageList = new PageListBean();
    pageList = this.state.pageList;
    let requestInput = new RestAccountReceivableListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.AccountReceivableMaintenanceView_IsAccessible()) {
      AccountReceivableService.getAccountReceivablePageList(
        requestInput,
        this.loadAccountReceivablePageResponse,
        this.loadAccountReceivablePageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  moduleCaption = "Account Receivable";
  moduleExit = () => {
    let arData = this.state.arData;
    if (arData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockAccountReceivable(arData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    this.hideAlertCallBack();
    let pageTitle = this.moduleCaption;
    this.setState({
      isAccountReceivableListFormOpen: true,
      isAccountReceivableEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowBackButton: false,
      isShowCancelButton: false,
      isShowReverseButton: false,
      isShowPostButton: false,
      pageTitle: pageTitle,
      error_list: [],
      isSpecialViewMode: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isShowModuleSearchContainer: false,
      isResetView: false,
      isShowNodes: false,
      isMaintenanceMode: false,
      isShowLookup: false,
      disableARFormFields: false,
      isDisabledFields: false,
      invLines: new Array(),
      crediMemoLines: new Array(),
      isViewMode: false,
      isNotFound: false,
      arData: new AccountReceivableBean(),
      invoiceCriteria: new InvoiceSearchCriteria(),
      isShowPopupAlertlvl1: false,
      isShowAlertLvl3: false,
    });
  };
  save = () => {
    this.saveAccountReceivable();
  };
  unlockAccountReceivableResponse = (response) => {
    this.setState({ isLoading: false });
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editAccountReceivable(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        this.isLocked = false; //optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockAccountReceivableError = (error) => {
    let errList = [];
    errList.push(error.toString());
    this.setState({ error_list: errList, isLoading: false });
  };
  unlockAccountReceivable = (arNunber) => {
    this.setState({ isLoading: true });
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = arNunber;
    if (SecurityAccessManager.AccountReceivableMaintenance_IsAccessible()) {
      AccountReceivableService.unLockAccountReceivableNumber(
        request,
        this.unlockAccountReceivableResponse,
        this.unlockAccountReceivableError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelAccountReceivableResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.accountReceivable !== null &&
      isSuccess
    ) {
      let ar = response.data.accountReceivable;
      if (ar !== null) {
        this.setState({
          arData: ar,
          isDisableFields: true,
        });
        this.closeEntryForm();
        if (this.isLocked) {
          this.code = ar.code;
          this.isLocked = false;
          this.unlockAccountReceivable(ar.code);
        }
        this.loadAccountReceivablePage();
      }
    }
  };
  cancelAccountReceivableError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  cancelAccountReceivable = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling ..",
    });
    let request = new RestAccountReceivableBeanRequest();
    request.isWarningAcceptedForCreditMemoGenerationForOverPayment = false;
    request.lockCheckRequired = false;
    request.accountReceivableBean = this.state.arData;
    let reasonBean = new ReasonBean();
    reasonBean.code = "WR";
    reasonBean.description = "Wrong entry";
    request.reason = reasonBean;
    request.specialReason = reasonBean.description;
    if (
      SecurityAccessManager.AccountReceivableMaintenanceCancel_IsAccessible()
    ) {
      AccountReceivableService.cancelAccountReceivable(
        request,
        this.cancelAccountReceivableResponse,
        this.cancelAccountReceivableError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  reverseAccountReceivable = () => {
    this.openReasonCapture(1);
  };
  saveReverseAccountReceivableResponse = (response) => {
    // console.log("saveReverseAccountReceivableResponse",response)
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.accountReceivable !== null &&
      isSuccess
    ) {
      let ar = response.data.accountReceivable;
      if (ar !== null) {
        this.setState({
          arData: ar,
          isDisableFields: true,
        });
        // this.closeEntryForm();   ----->Texco Excel Issue Noted  by (Arun)
        // this.unlockAccountReceivable(ar.code);
        if (this.isLocked) {
          this.code = ar.code;
          this.isLocked = false;
          this.unlockAccountReceivable(ar.code);
        }
        // this.loadAccountReceivablePage(); ----->Texco Excel Issue Noted  by (Arun)
      }
    }
  };
  saveReverseAccountReceivableError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  saveReverseAccountReceivable = () => {
    this.setState({
      isLoading: true,
      loadingText: "Reversing ..",
    });
    let request = new RestAccountReceivableBeanRequest();
    request.isWarningAcceptedForCreditMemoGenerationForOverPayment = false;
    request.lockCheckRequired = false;
    request.accountReceivableBean = this.state.arData;
    let reasonBean = new ReasonBean();
    reasonBean.code = this.state.reasonData.code;
    reasonBean.description = this.state.reasonData.description;
    request.reasonBean = reasonBean;
    request.specialReason = reasonBean.description;
    // console.log("request",request)
    if (
      SecurityAccessManager.AccountReceivableMaintenanceReverse_IsAccessible()
    ) {
      AccountReceivableService.reverseAccountReceivable(
        request,
        this.saveReverseAccountReceivableResponse,
        this.saveReverseAccountReceivableError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  postAccountReceivableResponse = (response) => {
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.accountReceivable !== null &&
      isSuccess
    ) {
      let ar = response.data.accountReceivable;
      if (ar !== null) {
        let isDisableFields = false;
        if (
          ar.accountReceivableStatus === "F" ||
          ar.accountReceivableStatus === "R" ||
          ar.accountReceivableStatus === "X"
        ) {
          isDisableFields = true;
        }
        this.setState({
          arData: ar,
          isDisableFields: isDisableFields,
        });
        this.editAccountReceivable(ar.code);
      }
    }
  };
  postAccountReceivableError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  postAccountReceivable = () => {
    let isValid = this.isValidatetoPay();
    let warningMessage = "";
    if (isValid) {
      if (this.OpenAmount_Calc() > 0 && this.inCompleteInvoiceAppliedAmount) {
        warningMessage =
          "[Warning] UnApplied Open Invoices Found." +
          "\n" +
          " Do you want to proceed with the Credit Memo generation for Remaining Amount(Available to Apply Amount)?";
        this.setState({
          warningMessage: warningMessage,
        });
        this.warningMessageForCredit();
      } else if (this.OpenAmount_Calc > 0) {
        warningMessage =
          "[Warning] Credit Memo will be generated for Remaining Amount(UnApplied Amount)!" +
          "\n" +
          " Do you want to proceed with the Warning?";
        this.setState({
          warningMessage: warningMessage,
        });
        this.warningMessageForCredit();
      } else {
        this.saveAndPostAccountReceivable();
      }
    }
  };
  saveAndPostAccountReceivable = () => {
    this.setState({
      isLoading: true,
      loadingText: "Posting ..",
    });
    let request = new RestAccountReceivableBeanRequest();
    request.isWarningAcceptedForCreditMemoGenerationForOverPayment =
      this.state.isSavedWithWarning;
    request.isLockRequired = false;
    const arData = { ...this.state.arData };
    const checkDetail = this.state.checkDetail;
    const cardDetail = this.state.cardDetail;
    const wireDetail = this.state.wireDetail;
    const achDetail = this.state.achDetail;
    arData.checkDetailLines = new Array();
    arData.cardDetailLines = new Array();
    arData.wireTransferDetailLines = new Array();
    arData.autoClearingHouseDetailLines = new Array();
    // identify Payment Type and set values ontheir object
    if (!isEmptyString(arData.checkAmount) && arData.checkAmount > 0) {
      checkDetail.companyCode = arData.companyCode;
      checkDetail.currencyCode = arData.companyCurrencyCode;
      arData.checkDetailLines.push(checkDetail);
    }
    if (
      !isEmptyString(arData.wireTransferAmount) &&
      arData.wireTransferAmount > 0
    ) {
      wireDetail.companyCode = arData.companyCode;
      wireDetail.currencyCode = arData.companyCurrencyCode;
      arData.wireTransferDetailLines.push(wireDetail);
    }
    if (
      !isEmptyString(arData.autoClearingHouseAmount) &&
      arData.autoClearingHouseAmount > 0
    ) {
      achDetail.companyCode = arData.companyCode;
      achDetail.currencyCode = arData.companyCurrencyCode;
      arData.autoClearingHouseDetailLines.push(achDetail);
    }
    if (!isEmptyString(arData.cardAmount) && arData.cardAmount > 0) {
      cardDetail.companyCode = arData.companyCode;
      cardDetail.currencyCode = arData.companyCurrencyCode;
      arData.cardDetailLines.push(cardDetail);
    }

    let arLines = arData.lines;
    let cpyArLines = [];
    cpyArLines.push(...arLines);
    arData.lines = [];
    cpyArLines.map((arLine) => {
      if ((arLine.selectedFlag || arLine.isFetched) && !arLine.creditMemoFlag)
        arData.lines.push(arLine);
      else if (arLine.creditMemoFlag && arLine.creditMemoAppliedAmount !== 0) {
        let creditMemoLine = new AccountReceivableAppliedCreditMemoLineBean();
        creditMemoLine.companyCode = arData.companyCode;
        creditMemoLine.accountReceivableNumber = arData.code;
        creditMemoLine.creditMemoNumber = arLine.invoiceNumber;
        creditMemoLine.creditMemoAmount = arLine.openInvoiceAmount;
        creditMemoLine.creditMemoAppliedAmount = arLine.creditMemoAppliedAmount;
        creditMemoLine.currencyCode = arLine.currencyCode;
        if (creditMemoLine.creditMemoAmount < 0)
          creditMemoLine.creditMemoAmount = -creditMemoLine.creditMemoAmount;
        else creditMemoLine.creditMemoAmount = creditMemoLine.creditMemoAmount;
        if (creditMemoLine.creditMemoAppliedAmount < 0)
          creditMemoLine.creditMemoAppliedAmount =
            -creditMemoLine.creditMemoAppliedAmount;
        else
          creditMemoLine.creditMemoAppliedAmount =
            creditMemoLine.creditMemoAppliedAmount;
        creditMemoLine.standardCreditMemoAmount = 0;
        creditMemoLine.standardCreditMemoAppliedAmount = 0;
        let exisitingLine = this.getAppliedCreditMemoLine(
          creditMemoLine.creditMemoNumber,
        );
        if (exisitingLine === null) {
          arData.appliedCreditMemoLines.push(creditMemoLine);
        }
      }
    });
    // commented by guru 05-08-2023
    // this.state.arData = arData;
    arData.applicableCreditMemos.map((cmLine) => {
      if (cmLine.creditMemoAmount < 0)
        cmLine.creditMemoAmount = -cmLine.creditMemoAmount;
      else cmLine.creditMemoAmount = cmLine.creditMemoAmount;
      if (cmLine.creditMemoAppliedAmount < 0)
        cmLine.creditMemoAppliedAmount = -cmLine.creditMemoAppliedAmount;
      else cmLine.creditMemoAppliedAmount = -cmLine.creditMemoAppliedAmount;
      if (!arData.isFetched) {
        let arLine = this.getARLine(cpyArLines, cmLine.creditMemoNumber);
        if (arLine != null) {
          cmLine.creditMemoAppliedAmount = arLine.creditMemoAppliedAmount;
        }
      }
    });
    request.accountReceivableBean = arData;

    // console.log("post request ##*", request);

    if (this.state.arData.isFetched) {
      if (
        SecurityAccessManager.AccountReceivableMaintenanceEdit_IsAccessible()
      ) {
        AccountReceivableService.updateAndApproveAccountReceivable(
          request,
          this.postUpdateApproveAccountReceivableResponse,
          this.postAccountReceivableError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.AccountReceivableMaintenanceAdd_IsAccessible()
      ) {
        AccountReceivableService.createAndApproveAccountReceivable(
          request,
          this.postApproveAccountReceivableResponse,
          this.postAccountReceivableError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  postApproveAccountReceivableResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleApproveResponse(response.data);
    let errList = [];
    if (!isEmpty(response.data)) {
      if (!isEmpty(response.data.additionalOperationResponse)) {
        if (response.data.additionalOperationResponse.warnings != null) {
          response.data.additionalOperationResponse.warnings.map((err) =>
            ShowError(err.messageDescription),
          );
        }
      }
      if (
        response.data.mainOperationResponse != null &&
        response.data.mainOperationResponse.result != null &&
        response.data.mainOperationResponse.result.accountReceivable != null &&
        isSuccess === true
      ) {
        let ar = response.data.mainOperationResponse.result.accountReceivable;
        this.state.arData = ar;
        this.generatePDF();
        // this.unlockAccountReceivable(ar.code);
        // this.editAccountReceivable(ar.code);
        if (!this.isLocked) {
          this.editAccountReceivable(ar.code);
        } else {
          this.code = ar.code;
          this.unlockAccountReceivable(ar.code);
        }
      }
    }
  };
  postUpdateApproveAccountReceivableResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let isSuccess = this.handleApproveResponse(response.data);
    let errList = [];
    if (!isEmpty(response.data)) {
      if (!isEmpty(response.data.additionalOperationResponse)) {
        if (response.data.additionalOperationResponse.warnings != null) {
          response.data.additionalOperationResponse.warnings.map((err) =>
            ShowError(err.messageDescription),
          );
        }
      }
      if (
        response.data.mainOperationResponse != null &&
        response.data.mainOperationResponse.accountReceivable != null &&
        isSuccess === true
      ) {
        let ar = response.data.mainOperationResponse.accountReceivable;
        this.state.arData = ar;
        this.generatePDF();
        // this.unlockAccountReceivable(ar.code);
        // this.editAccountReceivable(ar.code);

        if (this.isLocked) {
          this.code = ar.code;
          this.unlockAccountReceivable(ar.code);
        }
      }
    }
  };
  handleApproveResponse = (response) => {
    let success = false;
    let mainResponseSuccess = false;
    let additionalResponseSuccess = false;

    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.mainOperationResponse != null) {
      if (response.mainOperationResponse.errors != null) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        mainResponseSuccess = false;
      }
      if (response.mainOperationResponse.infos != null) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription),
        );
        mainResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    if (response.additionalOperationResponse != null) {
      if (response.additionalOperationResponse.errors != null) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        additionalResponseSuccess = false;
      }
      if (response.additionalOperationResponse.infos != null) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription),
        );
        additionalResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    success = mainResponseSuccess && additionalResponseSuccess;
    return success;
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  filterAR = () => {
    this.loadPage(1);
  };

  addNewEntry = () => {
    let arData = new AccountReceivableBean();
    arData.companyCode = this.companyCode;
    arData.code = NEW_ENTRY;
    arData.accountReceivableDate = toFormattedDate_v1(new Date());
    arData.accountReceivableStatus = "O";
    let customerdata = new CustomerBean();
    let customer_list = new Array();
    customer_list = this.state.customer_list;
    customerdata = customer_list;
    let pageTitle = this.moduleCaption + " - NEW";
    arData.paymentTypeCode = "CHECK";
    arData.customerName = " ";
    let isCheckPayment = true;
    let isCashPayment = false;
    let isCardPayment = false;
    let isWirePayment = false;
    let isAchPayment = false;
    let isOtherPayment = false;
    let checkDetail = new AccountReceivableCheckDetailBean();
    checkDetail.companyCode = this.companyCode;
    let cardDetail = new AccountReceivableCardDetailBean();
    cardDetail.isPaymentProcessRequired = true;
    if (this.state.arData.paymentTypeCode === "DEBITCARD") {
      cardDetail.isDebitCard = true;
    }
    if (!isEmptyString(this.state.moduleKeyCode)) {
      arData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else arData.code = NEW_ENTRY;
    this.setState({
      arData: arData,
      customerdata: customerdata,
      pageTitle: pageTitle,
      isCheckPayment: isCheckPayment,
      isCardPayment: isCardPayment,
      isCashPayment: isCashPayment,
      isWirePayment: isWirePayment,
      isAchPayment: isAchPayment,
      isOtherPayment: isOtherPayment,
      checkDetail: checkDetail,
      cardDetail: cardDetail,
      isCardPayment: false,
      isCashPayment: false,
      isAutoCalculate: false,
      statusTrackList: new Array(),
    });
    this.state.isDisableFields = false;
    this.state.isCollapsible_open = true;
    this.state.arData = arData;
    this.openEntryForm();
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isAccountReceivableListFormOpen: false,
      isAccountReceivableEntryFormOpen: false,
      isARHistoryFormOpened: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let arData = this.state.arData;
    let headerObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let historyNode = new NodeData("historyView", "History", historyObject);
    nodeList["headerView"] = headerNode;
    if (arData.isFetched == true) {
      nodeList["historyView"] = historyNode;
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setARHeaderView();
    } else if (selectedNode == "historyView") {
      this.setARHistoryView();
    }
  };
  setARHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isAccountReceivableListFormOpen: false,
      isAccountReceivableEntryFormOpen: true,
      isARHistoryFormOpened: false,
    });
  };
  setARHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isAccountReceivableListFormOpen: false,
      isAccountReceivableEntryFormOpen: false,
      isARHistoryFormOpened: true,
    });
  };
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.clearError();
    let arData = this.state.arData;
    console.log("arData..", arData);
    this.setState({
      isAccountReceivableListFormOpen: false,
      isAccountReceivableEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowMailButton: false,
      isShowPostButton: true,
      isShowCancelButton: true,
      arLineData: new AccountReceivableLineBean(),
      isShowModuleSearchContainer: true,
      isResetView: false,
      isShowNodes: true,
      isShowAutoCompleteBillToList: false,
      billToPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isAutoApply: false,
    });
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let arStatus = ModuleUtils.getARStatusCaption(
      this.state.arData.accountReceivableStatus,
    );
    if (arStatus !== undefined && arStatus !== null) {
      moduleOrderStatus = arStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isAccountReceivableListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
        disableARFormFields: false,
      });
    } else {
      this.setState({
        isDisabledFields: true,
        disableARFormFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    if (arData.isFetched) {
      if (
        arData.accountReceivableStatus ==
        LogicConstants.ACCOUNT_RECEIVABLE_OPEN_STATUS
      ) {
        this.setState({
          isShowCancelButton: true,
          isShowPostButton: true,
          isShowPDFReportButton: true,
          isShowMailButton: true,
          isDisableFields: false,
          disableARFormFields: true,
          isShowSaveButton: false,
          isDisabledFields: false,
        });
      } else if (
        arData.accountReceivableStatus ==
        LogicConstants.ACCOUNT_RECEIVABLE_CANCEL_STATUS
      ) {
        this.setState({
          isShowPostButton: false,
          isShowCancelButton: false,
          isShowSaveButton: false,
          isShowReverseButton: false,
          isShowClearCriteriaButton: false,
          isShowPDFReportButton: true,
          isShowMailButton: true,
          isDisableFields: true,
          disableARFormFields: true,
          isDisabledFields: false,
        });
      } else if (
        arData.accountReceivableStatus ==
        LogicConstants.ACCOUNT_RECEIVABLE_FINISHED_STATUS
      ) {
        this.setState({
          isShowPostButton: false,
          isShowCancelButton: false,
          isShowSaveButton: false,
          isShowBackButton: true,
          isShowReverseButton: true,
          isShowPaymentHistoryButton: true,
          isShowPDFReportButton: true,
          isShowMailButton: true,
          isDisableFields: true,
          disableARFormFields: true,
          isDisabledFields: false,
        });
      } else if (
        arData.accountReceivableStatus ==
        LogicConstants.ACCOUNT_RECEIVABLE_REVERSE_STATUS
      ) {
        this.setState({
          isShowPostButton: false,
          isShowCancelButton: false,
          isShowSaveButton: false,
          isShowBackButton: true,
          isShowReverseButton: false,
          isShowClearCriteriaButton: false,
          isShowPDFReportButton: true,
          isShowMailButton: true,
          isDisableFields: true,
          disableARFormFields: true,
          isDisabledFields: false,
        });
      }
    }
    if (arData.isFetched == false) {
      this.setState({
        isShowPostButton: true,
        isShowSaveButton: true,
        isShowCancelButton: false,
        isShowReverseButton: false,
        isShowPaymentHistoryButton: false,
        isDisableFields: false,
        disableARFormFields: false,
      });
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        isDisableFields: true,
        disableARFormFields: true,
        disabled: true,
        pageTitle: pageTitle,
        isDisabledFields: true,
      });
    }
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editAccountReceivableResponse = (response) => {
    console.log("edit response:", response);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    let errMsg = "";
    if (response.data.accountReceivableResponse != null) {
      if (response.data.accountReceivableResponse.errors != null) {
        response.data.accountReceivableResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (
      errMsg !=
      "AccountReceivable [" + this.state.moduleKeyCode + "] Not read!"
    ) {
      this.showErrorMessage(response.data.accountReceivableResponse);
    }
    if (
      response.data != null &&
      response.data.accountReceivableResponse !== null
    ) {
      const ar = response.data.accountReceivableResponse.accountReceivable;
      if (ar !== null) {
        let moduleKeyCode = ar.code;
        let isDisableFields = false;
        if (ar.isFetched) isDisableFields = true;
        let isCheckPayment = false;
        let isCashPayment = false;
        let isCardPayment = false;
        let isWirePayment = false;
        let isAchPayment = false;
        let isOtherPayment = false;
        let paymentLine = null;
        if (ar.paymentLines != null && ar.paymentLines.length > 0) {
          let paymentLine = ar.paymentLines[0];
          if (paymentLine.paymentType == 1) {
            ar.paymentTypeCode = "CHECK";
            isCheckPayment = true;
          } else if (paymentLine.paymentType == 3) {
            ar.paymentTypeCode = "CREDITCARD";
            isCardPayment = true;
          } else if (paymentLine.paymentType == 4) {
            ar.paymentTypeCode = "DEBITCARD";
            isCardPayment = true;
          } else if (paymentLine.paymentType == 5) {
            ar.paymentTypeCode = "CASH";
            isCashPayment = true;
          } else if (paymentLine.paymentType == 8) {
            ar.paymentTypeCode = "WIRE";
            isWirePayment = true;
          } else if (paymentLine.paymentType == 9) {
            ar.paymentTypeCode = "ACH";
            isAchPayment = true;
          } else {
            ar.paymentTypeCode = "";
            isOtherPayment = true;
          }
        }
        if (ar.checkDetailLines != null && ar.checkDetailLines.length > 0) {
          let checkDetail = ar.checkDetailLines[0];
          this.setState({ checkDetail: checkDetail });
        }
        if (ar.cardDetailLines != null && ar.cardDetailLines.length > 0) {
          let cardDetail = ar.cardDetailLines[0];
          this.setState({ cardDetail: cardDetail });
        }
        if (
          ar.wireTransferDetailLines != null &&
          ar.wireTransferDetailLines.length > 0
        ) {
          let wireDetail = ar.wireTransferDetailLines[0];
          this.setState({ wireDetail: wireDetail });
        }
        if (
          ar.autoClearingHouseDetailLines != null &&
          ar.autoClearingHouseDetailLines.length > 0
        ) {
          let achDetail = ar.autoClearingHouseDetailLines[0];
          this.setState({ achDetail: achDetail });
        }
        let arLines = [];
        if (
          !isEmptyArray(ar.applicableInvoices)
          // ar.applicableInvoices !== null &&
          // ar.applicableInvoices.length > 0
        ) {
          ar.applicableInvoices.map((inv) => {
            let arLine = new AccountReceivableLineBean();
            arLine.companyCode = ar.companyCode;
            arLine.accountReceivableNumber = ar.code;
            arLine.invoiceNumber = inv.invoiceNumber;
            arLine.currencyCode = inv.currencyCode;
            arLine.invoiceDate = inv.invoiceCreatedDate;
            arLine.openInvoiceAmount =
              inv.invoiceGrandTotalAmount - inv.invoicePaidAmount;
            arLine.openInvoiceAmount = arLine.openInvoiceAmount.toFixed(2);
            let grantTotalAmount = parseFloat(
              inv.invoiceGrandTotalAmount,
            ).toFixed(2);
            arLine.grantTotalAmount = grantTotalAmount;
            let postedPaidAmount = parseFloat(inv.invoicePaidAmount).toFixed(2);
            arLine.postedPaidAmount = postedPaidAmount;

            arLine.standardOpenInvoiceAmount = arLine.openInvoiceAmount;

            arLine.isFetched = false;
            ar.paymentLines.map((ln) => {
              if (ln.invoiceNumber === arLine.invoiceNumber) {
                arLine.selectedFlag = true;
                arLine.totalAppliedAmount = ln.paymentAmount;
              }
            });
            arLines.push(arLine);
          });
        }
        if (
          !isEmptyArray(ar.applicableCreditMemos)
          // ar.applicableCreditMemos !== null &&
          // ar.applicableCreditMemos.length > 0
        ) {
          ar.applicableCreditMemos.map((cmLine) => {
            let arLine = new AccountReceivableLineBean();
            arLine.companyCode = cmLine.companyCode;
            arLine.accountReceivableNumber = cmLine.accountReceivableNumber;
            arLine.invoiceNumber = cmLine.creditMemoNumber;
            arLine.currencyCode = cmLine.currencyCode;
            arLine.invoiceCreatedDate = cmLine.creditmemoCreatedDate;
            // arLine.openInvoiceAmount = -cmLine.creditMemoAppliedAmount;
            arLine.openInvoiceAmount = cmLine.applicableAmount;
            arLine.grantTotalAmount = -cmLine.creditMemoAmount;
            arLine.invoiceDate = cmLine.creditmemoCreatedDate;
            // arLine.postedPaidAmount = parseFloat(0).toFixed(2);
            arLine.isFetched = false;
            arLine.creditMemoFlag = true;
            if (!isEmptyArray(ar.appliedCreditMemoLines)) {
              ar.appliedCreditMemoLines.map((ln) => {
                if (ln.creditMemoNumber === arLine.invoiceNumber) {
                  arLine.selectedFlag = true;
                  arLine.creditMemoAppliedAmount = -ln.creditMemoAppliedAmount;
                  arLine.standardCreditMemoAppliedAmount =
                    arLine.creditMemoAppliedAmount;
                }
              });
            }
            arLines.push(arLine);
          });
        }
        let ar_lines = [];
        ar_lines.push(...arLines);

        let invList = [];
        if (!isEmptyArray(ar.lines) && !isEmptyArray(ar_lines)) {
          ar.lines.map((arLn) => {
            ar_lines.map((ln) => {
              if (arLn.invoiceNumber === ln.invoiceNumber) {
                invList.push(ln);
              }
            });
          });
        }
        if (!isEmptyArray(ar.lines) && !isEmptyArray(invList)) {
          ar.lines.map((arLn) => {
            invList.map((ln) => {
              if (arLn.invoiceNumber == ln.invoiceNumber) {
                if (!arLn.creditMemoFlag) {
                  ln.totalAppliedAmount = arLn.totalAppliedAmount;
                  ln.appliedAmount = arLn.totalAppliedAmount;
                  ln.standardAppliedAmount = ln.appliedAmount;
                  ln.standardTotalAppliedAmount = ln.appliedAmount;
                  ln.customerPurchaseOrderNumber =
                    arLn.customerPurchaseOrderNumber;
                  ln.isFetched = arLn.isFetched;
                } else {
                  ln.creditMemoAppliedAmount = arLn.creditMemoAppliedAmount;
                  ln.isFetched = arLn.isFetched;
                }

                ar_lines.push(ln);
              }
            });
          });
          ar.lines = arLines;
        }

        // if (!isEmptyArray(ar.lines) && !isEmptyArray(ar_lines)) {
        //   ar.lines.map((arLn) => {
        //     ar_lines.map((ln) => {
        //       if (
        //         ln.invoiceNumber === arLn.invoiceNumber &&
        //         !arLn.creditMemoFlag
        //       ) {
        //         ln.totalAppliedAmount = arLn.totalAppliedAmount;
        //         ln.customerPurchaseOrderNumber =
        //           arLn.customerPurchaseOrderNumber;
        //         ln.isFetched = arLn.isFetched;
        //       } else if (
        //         ln.invoiceNumber === arLn.invoiceNumber &&
        //         arLn.creditMemoFlag
        //       ) {
        //         ln.creditMemoAppliedAmount = arLn.creditMemoAppliedAmount;
        //         ln.isFetched = arLn.isFetched;
        //       }
        //       ar_lines.push(ln);
        //     });
        //   });
        //   ar.lines = arLines;
        // }
        let invoiceLines = new Array();
        let creditMemoLines = new Array();
        if (!isEmptyArray(ar.lines)) {
          ar.lines.map((ln) => {
            if (!ln.creditMemoFlag) {
              invoiceLines.push(ln);
            } else if (ln.creditMemoFlag) {
              creditMemoLines.push(ln);
            }
          });
        }
        let pageTitle = this.moduleCaption + " - EDIT";

        this.state.arData = ar;
        this.setState({
          arData: ar,
          pageTitle: pageTitle,
          isDisableFields: isDisableFields,
          isCheckPayment: isCheckPayment,
          isCardPayment: isCardPayment,
          isCashPayment: isCashPayment,
          isWirePayment: isWirePayment,
          isAchPayment: isAchPayment,
          isOtherPayment: isOtherPayment,
          moduleKeyCode: moduleKeyCode,
          // disabled: true,
          isFocus: true,
          invLines: invoiceLines,
          crediMemoLines: creditMemoLines,
          statusTrackList: ar.statusTracks,
          isFocusLookup: false,
        });
        this.isLocked = true;
        this.getNodeList();
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  editAccountReceivableError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  editAccountReceivable = (arNumber) => {
    this.setState({
      isLoading: true,
    });
    if (isEmptyString(arNumber)) return;
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = arNumber;

    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
      isLockRequired = false;
    } else {
      isLockRequired = NEW_ENTRY === arNumber ? false : true;
    }
    readrestInput.isLockRequired = isLockRequired;
    this.state.isDisableFields = true;
    if (SecurityAccessManager.AccountReceivableMaintenance_IsAccessible()) {
      AccountReceivableService.initAccountReceivableModule(
        readrestInput,
        this.editAccountReceivableResponse,
        this.editAccountReceivableError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getARLine = (lines, invoiceNumber) => {
    let arLine = null;
    if (!isEmptyString(invoiceNumber) && lines !== null && lines.length > 0) {
      lines.map((line) => {
        if (line.invoiceNumber === invoiceNumber) {
          arLine = line;
          return arLine;
        }
      });
    }
    return arLine;
  };
  getAppliedCreditMemoLine = (creditMemoNumber) => {
    let creditMemoLine = null;
    if (this.state.arData === null) return creditMemoLine;
    else if (this.state.arData.appliedCreditMemoLines === null)
      return creditMemoLine;
    else {
      this.state.arData.appliedCreditMemoLines.map((line) => {
        if (line.creditMemoNumber === creditMemoNumber) {
          creditMemoLine = line;
          return creditMemoLine;
        }
      });
    }
    return creditMemoLine;
  };
  saveAccountReceivableResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    let ar = this.state.arData;
    let isSuccess = this.handleResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.result) &&
      isSuccess
    ) {
      ar = response.data.result.accountReceivable;
      if (!isEmpty(ar)) {
        // let isDisableFields = false;
        // if (
        //   ar.accountReceivableStatus === "F" ||
        //   ar.accountReceivableStatus === "R" ||
        //   ar.accountReceivableStatus === "X"
        // ) {
        //   isDisableFields = true;
        // }
        // this.setState({
        //   isDisableFields: isDisableFields,
        // });
        // this.unlockAccountReceivable(ar.code);
        // this.editAccountReceivable(ar.code);

        if (!this.isLocked) {
          this.editAccountReceivable(ar.code);
        } else {
          this.code = ar.code;
          this.unlockAccountReceivable(ar.code);
        }
      }
    }
    this.setState({
      arData: ar,
    });
  };
  saveAccountReceivableError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  saveAccountReceivable = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let arData = { ...this.state.arData };
    let checkDetail = this.state.checkDetail;
    let cardDetail = this.state.cardDetail;
    let wireDetail = this.state.wireDetail;
    let achDetail = this.state.achDetail;
    arData.checkDetailLines = [];
    arData.cardDetailLines = [];
    arData.wireTransferDetailLines = [];
    arData.autoClearingHouseDetailLines = [];
    if (!isEmptyString(arData.checkAmount) && arData.checkAmount > 0) {
      checkDetail.companyCode = arData.companyCode;
      checkDetail.currencyCode = arData.companyCurrencyCode;
      arData.checkDetailLines.push(checkDetail);
    }
    if (
      !isEmptyString(arData.wireTransferAmount) &&
      arData.wireTransferAmount > 0
    ) {
      wireDetail.companyCode = arData.companyCode;
      wireDetail.currencyCode = arData.companyCurrencyCode;
      arData.wireTransferDetailLines.push(wireDetail);
    }
    if (
      !isEmptyString(arData.autoClearingHouseAmount) &&
      arData.autoClearingHouseAmount > 0
    ) {
      achDetail.companyCode = arData.companyCode;
      achDetail.currencyCode = arData.companyCurrencyCode;
      arData.autoClearingHouseDetailLines.push(achDetail);
    }
    if (!isEmptyString(arData.cardAmount) && arData.cardAmount > 0) {
      cardDetail.companyCode = arData.companyCode;
      cardDetail.currencyCode = arData.companyCurrencyCode;
      arData.cardDetailLines.push(cardDetail);
    }
    let arLines = arData.lines;
    let cpyArLines = [];
    cpyArLines.push(...arLines);
    arData.lines = [];
    cpyArLines.map((arLine) => {
      if ((arLine.selectedFlag || arLine.isFetched) && !arLine.creditMemoFlag)
        arData.lines.push(arLine);
      else if (arLine.creditMemoFlag && arLine.creditMemoAppliedAmount !== 0) {
        let creditMemoLine = new AccountReceivableAppliedCreditMemoLineBean();
        creditMemoLine.companyCode = arData.companyCode;
        creditMemoLine.accountReceivableNumber = arData.code;
        creditMemoLine.creditMemoNumber = arLine.invoiceNumber;
        creditMemoLine.creditMemoAmount = arLine.openInvoiceAmount;
        creditMemoLine.creditMemoAppliedAmount = arLine.creditMemoAppliedAmount;
        creditMemoLine.currencyCode = arLine.currencyCode;
        if (creditMemoLine.creditMemoAmount < 0)
          creditMemoLine.creditMemoAmount = -creditMemoLine.creditMemoAmount;
        else creditMemoLine.creditMemoAmount = creditMemoLine.creditMemoAmount;
        if (creditMemoLine.creditMemoAppliedAmount < 0)
          creditMemoLine.creditMemoAppliedAmount =
            -creditMemoLine.creditMemoAppliedAmount;
        else
          creditMemoLine.creditMemoAppliedAmount =
            creditMemoLine.creditMemoAppliedAmount;
        creditMemoLine.standardCreditMemoAmount = 0;
        creditMemoLine.standardCreditMemoAppliedAmount = 0;
        let exisitingLine = this.getAppliedCreditMemoLine(
          creditMemoLine.creditMemoNumber,
        );
        if (exisitingLine === null) {
          arData.appliedCreditMemoLines.push(creditMemoLine);
        }
      }
    });
    arData.applicableCreditMemos.map((cmLine) => {
      if (cmLine.creditMemoAmount < 0)
        cmLine.creditMemoAmount = -cmLine.creditMemoAmount;
      else cmLine.creditMemoAmount = cmLine.creditMemoAmount;
      if (cmLine.creditMemoAppliedAmount < 0)
        cmLine.creditMemoAppliedAmount = -cmLine.creditMemoAppliedAmount;
      else cmLine.creditMemoAppliedAmount = -cmLine.creditMemoAppliedAmount;
      if (!arData.isFetched) {
        let arLine = this.getARLine(cpyArLines, cmLine.creditMemoNumber);
        if (arLine != null) {
          cmLine.creditMemoAppliedAmount = arLine.creditMemoAppliedAmount;
        }
      }
    });

    // console.log("arData save request :", arData);

    if (arData.isFetched) {
      if (
        SecurityAccessManager.AccountReceivableMaintenanceEdit_IsAccessible()
      ) {
        AccountReceivableService.updateAccountReceivable(
          arData,
          this.saveAccountReceivableResponse,
          this.saveAccountReceivableError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      console.log("arData: save request", arData);
      if (
        SecurityAccessManager.AccountReceivableMaintenanceAdd_IsAccessible()
      ) {
        AccountReceivableService.createAccountReceivable(
          arData,
          this.saveAccountReceivableResponse,
          this.saveAccountReceivableError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  _executeAfterModalClose = (e) => {};
  listFormOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  resetFilteredAR = () => {
    let criteria = new AccountReceivableSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.isAdvanceSearch = false;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = new AccountReceivableSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.state.pageList = pageInput;
    this.loadAccountReceivablePage();
  };
  getModuleListView = () => {
    let arData = this.state.arData;
    if (arData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadAccountReceivablePage();
      this.setState({ isCardPayment: false, isCashPayment: false });
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockAccountReceivable(arData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadAccountReceivablePage();
    }
  };
  resetView = () => {
    let arData = this.state.arData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockAccountReceivable(arData.code);
    } else {
      this.isLocked = false;
    }

    let _arData = new AccountReceivableBean();
    this.setState({
      isShowLookup: false,
      arData: _arData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      isCardPayment: false,
      isCheckPayment: false,
      isCashPayment: false,
      isWirePayment: false,
      isAchPayment: false,
      isOtherPayment: false,
      isShowAutoCompleteBillToList: false,
      billToPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isAutoApply: false,
      isAutoCalculate: false,
      disableARFormFields: false,
      isDisabledFields: false,
      isDisableFields: false,
      invLines: new Array(),
      crediMemoLines: new Array(),
      statusTrackList: new Array(),
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
      // let arData = this.state.arData;
      // this.unlockAccountReceivable(arData.code);
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editAccountReceivable(this.state.moduleKeyCode);
    }
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  onChange = (e) => {
    let temp_arData = this.state.arData;
    temp_arData[e.target.name] = e.target.value;
    this.setState({ arData: temp_arData });
  };
  paymentTypeOnChange = (e) => {
    let paymentTypeCode = e.target.value;
    this.state.isShowAutoCompletePaymentTypeList = true;
    let temp_arData = this.state.arData;
    let showAutoCompleteList = this.state.isShowAutoCompletePaymentTypeList;
    if (isEmpty(paymentTypeCode)) {
      this.state.isShowAutoCompletePaymentTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePaymentTypeList;
      let soLine = this.state.arData;
      soLine.paymentTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        arData: soLine,
        paymentTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && paymentTypeCode !== "") {
      this.readPaymentTypeCodeBySearchString(paymentTypeCode);
    }
    if (e.target.name == "paymentTypeCode") {
      temp_arData["paymentTypeCode"] = e.target.value;
      const arr = this.state.arPaymentTypes;
      const query = e.target.value;
      const found = this.isFound(arr, query);
      let productType_List = this.state.arPaymentTypes;
      if (found) {
        productType_List.map((pdtType) => {
          if (pdtType.code == e.target.value) {
            temp_arData["paymentTypeCode"] = pdtType.code;
            this.state.isShowAutoCompletePaymentTypeList = false;
            let showAutoCompleteList =
              this.state.isShowAutoCompletePaymentTypeList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
        this.setState({
          isNotFound: false,
        });
        this.setState({ arData: temp_arData });
        this.setPaymentType(e.target.value);
      } else {
        this.setState({
          isNotFound: true,
        });
      }
    }
  };
  isFound = (arr, query) => {
    var found = false;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].code.toLowerCase() == query.toLowerCase()) {
        found = true;
        break;
      }
    }
    return found;
  };
  readPaymentTypeCodeBySearchString(searchString) {
    let paymentTypeCodeData = this.state.arPaymentTypes;
    let simpleAutoCompleteList = new Array();
    if (paymentTypeCodeData.length > 0 && paymentTypeCodeData != null) {
      paymentTypeCodeData.map((paymentTypeCodeDatas) => {
        let simpleItemBean = {
          code: paymentTypeCodeDatas.code,
          description: paymentTypeCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (paymentType) =>
        paymentType.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      paymentTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  paymentTypeEnterKeyEventHandler = (e) => {
    let temp_arData = this.state.arData;
    const arr = this.state.arPaymentTypes;
    const query = e.target.value;
    const found = this.isFound(arr, query);
    if (found) {
      temp_arData["paymentTypeCode"] = e.target.value;
      let productType_List = this.state.arPaymentTypes;
      let paymentTypeCodeBean = null;

      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          paymentTypeCodeBean = pdtType;
        }
      });
      if (!isEmpty(paymentTypeCodeBean)) {
        let temp_arData = this.state.arData;
        temp_arData.seasonCode = paymentTypeCodeBean.code;
        this.setState({
          arData: temp_arData,
          paymentTypePageListForAutoCompleteList: new Array(),
        });
      }
      this.setState({
        isNotFound: false,
      });
      this.setPaymentType(e.target.value);
    } else {
      this.setState({
        isNotFound: true,
      });
    }
  };
  displayAutoCompletePaymentTermList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompletePaymentTypeList: showAutoCompleteList });
  };
  setPaymentType = (value) => {
    let isCheckPayment = false;
    let isCashPayment = false;
    let isCardPayment = false;
    let isWirePayment = false;
    let isAchPayment = false;
    let isOtherPayment = false;
    let cardDetail = new AccountReceivableCardDetailBean();
    let checkDetail = new AccountReceivableCheckDetailBean();
    let wireDetail = new AccountReceivableWireTransferDetailBean();
    let achDetail = new AccountReceivableAutoClearingHouseDetailBean();
    const arData = this.state.arData;
    if (value == "CHECK") {
      isCheckPayment = true;
      arData.cashAmount = 0;

      arData.WireNumber = 0;
      arData.wireTransferAmount = 0;
      arData.wireTransferDetailLines = new Array();

      arData.cardNumber = 0;
      arData.cardAmount = 0;
      arData.cardDetailLines = new Array();

      arData.checkNumber = 0;
      arData.checkAmount = 0;
      arData.checkDetailLines = new Array();

      arData.achNumber = 0;
      arData.autoClearingHouseAmount = 0;
      arData.autoClearingHouseDetailLines = new Array();
    } else if (value == "CREDITCARD" || value == "DEBITCARD") {
      cardDetail.isPaymentProcessRequired = true;
      arData.cashAmount = 0;

      arData.WireNumber = 0;
      arData.wireTransferAmount = 0;
      arData.wireTransferDetailLines = new Array();

      arData.cardNumber = 0;
      arData.cardAmount = 0;
      arData.cardDetailLines = new Array();

      arData.checkNumber = 0;
      arData.checkAmount = 0;
      arData.checkDetailLines = new Array();

      arData.achNumber = 0;
      arData.autoClearingHouseAmount = 0;
      arData.autoClearingHouseDetailLines = new Array();
      if (this.state.arData.paymentTypeCode === "DEBITCARD") {
        cardDetail.isDebitCard = true;
        arData.cashAmount = 0;

        arData.WireNumber = 0;
        arData.wireTransferAmount = 0;
        arData.wireTransferDetailLines = new Array();

        arData.cardNumber = 0;
        arData.cardAmount = 0;
        arData.cardDetailLines = new Array();

        arData.checkNumber = 0;
        arData.checkAmount = 0;
        arData.checkDetailLines = new Array();

        arData.achNumber = 0;
        arData.autoClearingHouseAmount = 0;
        arData.autoClearingHouseDetailLines = new Array();
      }
      isCardPayment = true;
    } else if (value == "CASH") {
      isCashPayment = true;
      arData.cashAmount = 0;

      arData.WireNumber = 0;
      arData.wireTransferAmount = 0;
      arData.wireTransferDetailLines = new Array();

      arData.cardNumber = 0;
      arData.cardAmount = 0;
      arData.cardDetailLines = new Array();

      arData.checkNumber = 0;
      arData.checkAmount = 0;
      arData.checkDetailLines = new Array();

      arData.achNumber = 0;
      arData.autoClearingHouseAmount = 0;
      arData.autoClearingHouseDetailLines = new Array();
    } else if (value == "WIRE") {
      isWirePayment = true;
      // clear all data

      arData.cashAmount = 0;

      arData.WireNumber = 0;
      arData.wireTransferAmount = 0;
      arData.wireTransferDetailLines = new Array();

      arData.cardNumber = 0;
      arData.cardAmount = 0;
      arData.cardDetailLines = new Array();

      arData.checkNumber = 0;
      arData.checkAmount = 0;
      arData.checkDetailLines = new Array();

      arData.achNumber = 0;
      arData.autoClearingHouseAmount = 0;
      arData.autoClearingHouseDetailLines = new Array();
    } else if (value == "ACH") {
      isAchPayment = true;
      arData.cashAmount = 0;

      arData.WireNumber = 0;
      arData.wireTransferAmount = 0;
      arData.wireTransferDetailLines = new Array();

      arData.cardNumber = 0;
      arData.cardAmount = 0;
      arData.cardDetailLines = new Array();

      arData.checkNumber = 0;
      arData.checkAmount = 0;
      arData.checkDetailLines = new Array();

      arData.achNumber = 0;
      arData.autoClearingHouseAmount = 0;
      arData.autoClearingHouseDetailLines = new Array();
    } else {
      isOtherPayment = true;

      arData.cashAmount = 0;

      arData.WireNumber = 0;
      arData.wireTransferAmount = 0;
      arData.wireTransferDetailLines = new Array();

      arData.cardNumber = 0;
      arData.cardAmount = 0;
      arData.cardDetailLines = new Array();

      arData.checkNumber = 0;
      arData.checkAmount = 0;
      arData.checkDetailLines = new Array();

      arData.achNumber = 0;
      arData.autoClearingHouseAmount = 0;
      arData.autoClearingHouseDetailLines = new Array();
    }
    this.setState({
      cardDetail: cardDetail,
      checkDetail: checkDetail,
      wireDetail: wireDetail,
      achDetail: achDetail,
      arData: arData,
      isCheckPayment: isCheckPayment,
      isCardPayment: isCardPayment,
      isCashPayment: isCashPayment,
      isWirePayment: isWirePayment,
      isAchPayment: isAchPayment,
      isOtherPayment: isOtherPayment,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed });
  };
  getHistoryView() {
    return (
      <AccountReceivableHistoryDetailsForm
        {...this.state}
        arData={this.state.arData}
        handleSortingHistoryChange={this.handleSortingHistoryChange}
        statusTrackList={this.state.statusTrackList}
      />
    );
  }
  discountLineOnChange = (e) => {
    let temp_DiscLineData = this.state.discountDetail;
    temp_DiscLineData[e.target.name] = e.target.value;
    this.setState({
      discountDetail: temp_DiscLineData,
    });
  };
  addorUpdateDiscountLine = () => {
    let discountList = this.state.discountList;
    let discountLine = this.state.discountDetail;
    var lineNumber = this.getDiscountMaxLineNumber();
    let isValidLine = false;
    isValidLine = this.validateDiscLine(discountLine);
    if (isValidLine) {
      let isLineFound = false;
      if (discountList != null || !isEmptyArray(discountList)) {
        discountList.map((line, i) => {
          if (
            line.lineNumber == discountLine.lineNumber ||
            line.discountDetailReasonCode ==
              discountLine.discountDetailReasonCode
          ) {
            discountLine.lineNumber = line.lineNumber;
            line.discountAmount = discountLine.discountAmount;
            discountList[i] = line;
            isLineFound = true;
          }
        });
      }
      if (!isLineFound) {
        discountLine.lineNumber = ++lineNumber;
        discountList.push(discountLine);
      }
      this.setState({
        discountList: discountList,
      });
    }
    this.clearLines();
  };
  calculateTotalDiscount = () => {
    let arData = this.state.arData;
    let toaltalDiscAmt = 0;
    if (arData.discountDetails != null) {
      arData.discountDetails.map((line) => {
        toaltalDiscAmt += parseFloat(line.discountAmount);
      });
      arData.discountAmount = toaltalDiscAmt;
      this.setState({ arData: arData });
    }
  };
  getDiscountMaxLineNumber() {
    let maxLineNumber = 0;
    let discLines = this.state.discountList;
    if (discLines.length > 0)
      discLines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  validateDiscLine = (lineBean) => {
    let isValidDiscLine = false;
    let err_list = [];
    let errorMessage = "";
    if (lineBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lineBean.discountDetailReasonCode)) {
        let errMsg = "Reason is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (lineBean.discountAmount == 0) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidDiscLine = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlertlvl1: true,
        isShowAlert: false,
      });
    } else {
      isValidDiscLine = true;
      this.setState({ isShowPopupAlertlvl1: false, isShowAlert: false });
    }
    return isValidDiscLine;
  };
  handleDiscountLineNumberClick = (rowData) => {
    let lineData = { ...rowData };
    this.setState({
      discountDetail: lineData,
    });
  };
  clearLines = () => {
    this.setState({
      discountDetail: new AccountReceivableDiscountDetailBean(),
    });
  };
  warningMessageForCredit = () => {
    this.setState({
      isShowWarningMsgPopup: true,
    });
  };
  onYesButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(true);
  };
  onNoButtonClick = (isSavedWithWarning) => {
    this.isSavedWithWarning(false);
  };
  isSavedWithWarning = (isSavedWithWarning) => {
    this.state.isSavedWithWarning = isSavedWithWarning;
    this.setState({
      isSavedWithWarning: isSavedWithWarning,
    });
    if (isSavedWithWarning) {
      this.saveAndPostAccountReceivable();
    }
    this.closeMessageModelCallBack();
  };
  closeMessageModelCallBack = () => {
    this.setState({ isShowWarningMsgPopup: false });
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF...",
    });
    let arData = this.state.arData;
    arData.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let listRequest = new AccountReceivablePrintRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.arNumber = arData.code;
    listRequest.reportBean = reportBean;
    if (
      SecurityAccessManager.AccountReceivableMaintenancePDFReport_IsAccessible()
    ) {
      ReportService.generateAccountReceivablePrintReport(
        listRequest,
        this.generateARPrintReportPageResponse,
        this.generateARPrintReportPageError,
      );
    } else {
      let errMsg = "PDF Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generateARPrintReportPageResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmpty(response.data.reportResult)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
     
    }
  };
  generateARPrintReportPageError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  generatePaymentHistoryReport = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Payment History ..",
    });
    let arData = this.state.arData;
    arData.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = 1;
    let listRequest = new AccountReceivablePaymentHistoryPrintRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.accountReceivableNumber = arData.code;
    listRequest.reportBean = reportBean;
    if (SecurityAccessManager.AccountReceivableMaintenance_IsAccessible()) {
      ReportService.generateAccountReceivablePaymentHistoryPrintReport(
        listRequest,
        this.generatePaymentHistoryReportPageResponse,
        this.generatePaymentHistoryReportPageError,
      );
    } else {
      let errMsg = "PDF Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  generatePaymentHistoryReportPageResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.reportResult) &&
      !isEmpty(response.data.reportResult.reportFileID)
    ) {
      let reportFilePath = response.data.reportResult.reportFileID;
      window.open(this.report_url + reportFilePath);
    }
  };
  generatePaymentHistoryReportPageError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Erro : " + error);
  };
  createMail = () => {
    this.setState({ isShowMailPopup: true });
    let arData = this.state.arData;
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = arData.code;
    if (
      SecurityAccessManager.AccountReceivableMaintenanceSendMailReport_IsAccessible()
    ) {
      AccountReceivableService.fetchAccountReceivableMailDefaultInfoBean(
        request,
        this.fetchMailResponse,
        this.fetchMailError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  fetchMailResponse = (response) => {
    if (response.data != null) {
      let mailInfo = response.data.mailDefaultInfo;
      if (mailInfo != null) {
        this.setState({ mailInfoBean: mailInfo });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  fetchMailError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error :", error);
  };
  sendMail = (e) => {
    if (e.detail == 1) {
      this.clearError();
      let mailInfoBean = this.state.mailInfoBean;
      let arData = this.state.arData;
      arData.companyCode = this.companyCode;
      let reportBean = new RestReportBean();
      let request = new RestAccountReceivableMailInfoBeanRequest();
      request.companyCode = this.companyCode;
      request.code = arData.code;
      request.infoBean = mailInfoBean;
      request.inputReportBean = reportBean;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Sending Mail ..",
      });
      if (
        SecurityAccessManager.AccountReceivableMaintenanceSendMailReport_IsAccessible()
      ) {
        AccountReceivableService.sendAccountReceivableMail(
          request,
          this.sendMailResponse,
          this.sendMailError,
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  sendMailResponse = (response) => {
    if (response.data != null) {
      let isSuccess = this.handlePopupResponse(response.data);
      if (response.data !== null && isSuccess) {
        this.setState({
          isShowMailPopup: false,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  sendMailError = (error) => {
    ShowError("error :", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  handlePopupResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl3: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
        isShowAlertLvl3: false,
      });
      success = true;
    }
    return success;
  };
  mailOnChange = (e) => {
    let mailInfoBean = this.state.mailInfoBean;
    mailInfoBean[e.target.name] = e.target.value;
    this.setState({ mailInfoBean: mailInfoBean });
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  invoiceOnClick = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  creditMemoOnClick = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCMModule: true,
        moduleForPopup: (
          <PopupCreditMemoModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  lnkCustomerModule = (e) => {
    let customerCode = this.state.arData.customerCode;
    if (customerCode !== "" && customerCode !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={customerCode}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  openDiscountPopup = () => {
    let arData = this.state.arData;
    let discountList = [];
    if (!isEmptyArray(arData.discountDetails)) {
      arData.discountDetails.map((ln) => {
        discountList.push(ln);
      });
    }
    this.state.discountList = discountList;
    this.setState({
      discountList: discountList,
      isShowDiscountPopup: true,
    });
  };
  openCustomerOnOrderInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerOnOrderInq: true,
        moduleForPopup: (
          <PopupCustomerOnOrderInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerTransactionsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerTransactionsInq: true,
        moduleForPopup: (
          <PopupCustomerTransactionsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerStatisticsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerStatisticsInq: true,
        moduleForPopup: (
          <PopupCustomerStatisticsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerSalesHistoryInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerSalesHistoryInq: true,
        moduleForPopup: (
          <PopupCustomerSalesHistoryInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerMostRecentFabricsInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowCustomerMostRecentFabricsInq: true,
        moduleForPopup: (
          <PopupCustomerMostRecentFabricsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerCurrentAgingInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isCustomerCurrentAgingInq: true,
        moduleForPopup: (
          <PopupCustomerCurrentAgingInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  billToOnChange = (e) => {
    let billToCode = e.target.value;
    this.state.isShowAutoCompleteBillToList = true;
    let tempCriteria = this.state.arData;
    let showAutoCompleteList = this.state.isShowAutoCompleteBillToList;
    if (isEmpty(billToCode)) {
      this.state.isShowAutoCompleteBillToList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBillToList;
      let tempCriteria = this.state.arData;
      tempCriteria.billToCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        arData: tempCriteria,
        billToPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "billToCode" &&
      showAutoCompleteList === true &&
      billToCode !== ""
    ) {
      this.readBillToBySearchString(e.target.value);
    }
    this.readBillTo(billToCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ arData: tempCriteria });
  };
  billToEnterKeyEventHandler = (e) => {
    let billToCode = e.target.value;
    this.readBillTo(billToCode);
    this.state.isShowAutoCompleteBillToList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteBillToList;
    this.setState({
      billToPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayBillToAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteBillToList: isShowAutoCompleteList,
    });
  };
  readBillTo = (billToCode) => {
    let tempCriteria = this.state.arData;
    let billToBean = null;
    let BillToData = null;
    this.state.billTos.map((ln) => {
      if (ln.code === billToCode) {
        billToBean = ln;
        BillToData = new BaseBean();
        BillToData.code = ln.code;
        BillToData.description = ln.description;
      }
    });
    if (!isEmpty(billToBean)) {
      tempCriteria.billToCode = billToBean.code;
      this.state.isShowAutoCompleteBillToList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBillToList;
      this.setState({
        arData: tempCriteria,
        isShowAutoCompleteBillToList: showAutoCompleteList,
      });
    }
  };
  readBillToBySearchString = (searchString) => {
    let BillToData = this.state.billTos;
    let simpleAutoCompleteList = new Array();
    if (BillToData.length > 0 && BillToData != null) {
      BillToData.map((billTo) => {
        let billToBean = {
          code: billTo.code,
          description: billTo.description,
        };
        simpleAutoCompleteList.push(billToBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      billToPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  /***********DiscountPopup**********/
  discountReasonOnChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteDiscountList = true;
    let temp_DiscountData = this.state.discountDetail;
    let showAutoCompleteList = this.state.showAutoCompleteDiscountList;
    if (isEmpty(code)) {
      this.state.showAutoCompleteDiscountList = false;
      let showAutoCompleteList = this.state.showAutoCompleteDiscountList;
      temp_DiscountData.discountDetailReasonCode = "";
      temp_DiscountData.discountDetailReasonName = "";
      temp_DiscountData.discountAmount = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteDiscountList: showAutoCompleteList,
        discountDetail: temp_DiscountData,
        discountPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readDiscountReasonCodeBySearchString(code);
    }
    if (e.target.name == "discountDetailReasonCode") {
      temp_DiscountData["discountDetailReasonCode"] = e.target.value;
      let discount_List = this.state.discountReasons;
      discount_List.map((element) => {
        if (element.discountDetailReasonCode == e.target.value) {
          temp_DiscountData["discountDetailReasonCode"] = element.code;
          temp_DiscountData["discountDetailReasonName"] = element.description;
          temp_DiscountData["discountAmount"] = element.extraChargesAmount;
          this.state.showAutoCompleteDiscountList = false;
          let showAutoCompleteList = this.state.showAutoCompleteDiscountList;
          this.setState({
            showAutoCompleteDiscountList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ discountDetail: temp_DiscountData });
  };
  readDiscountReasonCodeBySearchString(searchString) {
    let reasonList = this.state.discountReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonList.length > 0 && reasonList != null) {
      reasonList.map((list) => {
        let simpleItemBean = {
          code: list.code,
          description: list.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (ln) => ln.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      discountPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  discountReasonEnterKeyEventHandler = (e) => {
    let temp_DiscountData = this.state.discountDetail;
    let reasonCode = e.target.value;
    temp_DiscountData["discountDetailReasonCode"] = e.target.value;
    let discount_List = this.state.discountReasons;
    let discountBean = null;
    discount_List.map((ln) => {
      if (ln.code == e.target.value) {
        discountBean = ln;
      }
    });
    if (!isEmpty(discountBean)) {
      temp_DiscountData.discountDetailReasonCode = discountBean.code;
      temp_DiscountData.discountDetailReasonName = discountBean.description;
      temp_DiscountData.discountAmount = discountBean.extraChargesAmount;
      this.setState({
        discountDetail: temp_DiscountData,
        discountPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteDiscountList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteDiscountList: showAutoCompleteList,
    });
  };
  addDiscountAmount = () => {
    let arData = this.state.arData;
    let list = [];
    this.state.discountList.map((ln) => {
      list.push(ln);
    });
    arData.discountDetails = list;
    this.setState({ arData: arData, discountList: [] });
    this.closeAlertDiscountModalCallBack(false);
  };
  reArrangeDiscountLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteLine = (rowData) => {
    let arData = this.state.arData;
    let tempList = this.state.discountList;
    if (!rowData.isFetched) {
      var index = tempList.indexOf(rowData);
      if (index > -1) {
        tempList.splice(index, 1);
      }
      this.reArrangeDiscountLineNumbers(tempList);
      this.setState({ arData: arData, discountList: tempList });
    }
  };
  advanceSearch = () => {
    this.setState({ isShowAdvanceSearchPopup: true });
  };
  onAdvanceSearchClick = (e) => {
    if (e.detail == 1) {
      this.loadPage(1);
      this.setState({
        isShowAdvanceSearchPopup: false,
        criteria: new AccountReceivableSearchCriteria(),
      });
    }
  };
  onAdvSearchChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  throwsError = () => {
    const errMsg = "Applied Amount should not exceed the Total Due Amount";
    const errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  inputBoxonBlurCallBack = (e, rowData) => {
    const _arData = { ...this.state.arData };
    const data = { ...rowData };
    const ar_Lines = [];
    if (e.target.name == "totalAppliedAmount") {
      if (!this.isCalculateandValidateAppliedAmount(e.target.value, data)) {
        this.throwsError();
      } else {
        _arData.lines.map((ln) => {
          if (ln.invoiceNumber === data.invoiceNumber) {
            ln[e.target.name] = e.target.value;
            ln.selectedFlag = true;
          }
          ar_Lines.push(ln);
          _arData.lines = ar_Lines;
        });
      }
    } else if (e.target.name == "creditMemoAppliedAmount") {
      if (!this.isCalculateandValidateCmAppliedAmount(e.target.value, data)) {
        this.throwsError();
      } else {
        _arData.lines.map((ln) => {
          if (
            ln.invoiceNumber === data.invoiceNumber &&
            ln.creditMemoFlag === true
          ) {
            // ln[e.target.name] = -e.target.value;
            ln[e.target.name] = -Math.abs(parseFloat(e.target.value) || 0);
            ln.selectedFlag = true;
          }
          ar_Lines.push(ln);
          _arData.lines = ar_Lines;
        });
      }
    }
    this.setState({
      arData: _arData,
    });
  };
  closeAlertDiscountModalCallBack = (isShowPopup) => {
    this.state.discountList = [];
    this.setState({
      isShowDiscountPopup: isShowPopup,
      discountList: [],
      isShowPopupAlertlvl1: false,
    });
    this.calculateTotalDiscount();
    this.clearLines();
  };
  hideAlertCallBacklvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl1: isDisplayed });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerSalesHistoryInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isCustomerCurrentAgingInq: false,
      isShowCMModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowMailPopup: isShowPopup,
      isShowAlert: isShowPopup,
      isShowAdvanceSearchPopup: isShowPopup,
    });
  };
  closeAlertProgressBarModalCallBack = (isShowPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowPopup,
    });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let accountreceivable_list = this.state.accountreceivable_list;
    if (sortField) {
      const sorted = [...accountreceivable_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ accountreceivable_list: sorted });
    }
  };

  handleSortingHistoryChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingHistory(sortField, sortOrder);
  };
  handleSortingHistory = (sortField, sortOrder) => {
    let list = this.state.statusTrackList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTrackList: sorted });
    }
  };

  handleSortingDiscountChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingDiscount(sortField, sortOrder);
  };
  handleSortingDiscount = (sortField, sortOrder) => {
    let list = this.state.discountList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ discountList: sorted });
    }
  };
  invoiceOnChange = (e) => {
    let invoiceCriteria = this.state.invoiceCriteria;
    invoiceCriteria[e.target.name] = e.target.value;
    this.setState({ invoiceCriteria: invoiceCriteria });
  };
  handleSearchInvoice = () => {
    let tempLines = [];
    let invLines = this.state.invLines;
    let invoiceNumber = this.state.invoiceCriteria.invoiceNumber;
    const result = invLines.filter(
      (invoice) => invoice.invoiceNumber === invoiceNumber,
    );

    console.log("result invoice:", result);
    this.setState({ invLines: result });
  };
  handleResetInvoice = () => {
    this.readAccountReceivableDependenciesOfCustomer();
    this.setState({ invoiceCriteria: new InvoiceSearchCriteria() });
  };
  render() {
    let criteria = this.state.criteria;
    return (
      <div>
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editAccountReceivable}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.accountReceivableLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {this.state.isAccountReceivableEntryFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              extend_toolbar={
                <ARModuleToolBar
                  cancelAccountReceivable={this.cancelAccountReceivable}
                  postAccountReceivable={this.postAccountReceivable}
                  reverseAccountReceivable={this.reverseAccountReceivable}
                  paymentHistoryReport={this.generatePaymentHistoryReport}
                  generateMail={this.createMail}
                  isShowPostButton={this.state.isShowPostButton}
                  isShowCancelButton={this.state.isShowCancelButton}
                  isShowReverseButton={this.state.isShowReverseButton}
                  isShowPaymentHistoryButton={
                    this.state.isShowPaymentHistoryButton
                  }
                  isShowMailButton={this.state.isShowMailButton}
                />
              }
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={this.state.moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isAccountReceivableListFormOpen &&
          !this.state.isARHistoryFormOpened &&
          this.state.isAccountReceivableEntryFormOpen}
        {this.state.isShowNodes &&
          !this.state.isAccountReceivableListFormOpen &&
          !this.state.isARHistoryFormOpened &&
          this.state.isAccountReceivableEntryFormOpen}
        {this.state.isShowNodes &&
          !this.state.isAccountReceivableListFormOpen &&
          this.state.isARHistoryFormOpened &&
          !this.state.isAccountReceivableEntryFormOpen &&
          this.getHistoryView()}
        {this.state.isAccountReceivableListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <AccountReceivableListForm
              {...this.state}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editAccountReceivable={this.editAccountReceivable}
              filterAR={this.filterAR}
              resetFilteredAR={this.resetFilteredAR}
              listFormOnChange={this.listFormOnChange}
              advanceSearch={this.advanceSearch}
              getCriteriaString={this.getCriteriaString}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        {this.state.isAccountReceivableEntryFormOpen && (
          <AccountReceivableEntryForm
            {...this.state}
            closeEntryForm={this.closeEntryForm}
            onChange={this.onChange}
            handleResponse={this.handleResponse}
            customerCodeOnChange={this.customerCodeOnChange}
            customerCodeEnterKeyEventHandler={
              this.customerCodeEnterKeyEventHandler
            }
            paymentTypeOnChange={this.paymentTypeOnChange}
            paymentTypeEnterKeyEventHandler={
              this.paymentTypeEnterKeyEventHandler
            }
            displayAutoCompletePaymentTermList={
              this.displayAutoCompletePaymentTermList
            }
            displayAutoCustomerCompleteList={
              this.displayAutoCustomerCompleteList
            }
            arOnChange={this.arOnChange}
            cardDetailsOnChange={this.cardDetailsOnChange}
            checkDetailsOnChange={this.checkDetailsOnChange}
            wireDetailsOnChange={this.wireDetailsOnChange}
            achDetailsOnChange={this.achDetailsOnChange}
            invoiceLineSelected={this.invoiceLineSelected}
            creditMemoLineSelected={this.creditMemoLineSelected}
            onAppliedAmountChange={this.onAppliedAmountChange}
            resetAppliedAmountClick={this.resetAppliedAmountClick}
            discountLineOnChange={this.discountLineOnChange}
            addorUpdateDiscountLine={this.addorUpdateDiscountLine}
            handleDiscountLineNumberClick={this.handleDiscountLineNumberClick}
            clearLines={this.clearLines}
            autoApplyClick={this.autoApplyClick}
            autoCalculateClick={this.autoCalculateClick}
            showHideSecondHeader={this.showHideSecondHeader}
            invoiceOnClick={this.invoiceOnClick}
            creditMemoOnClick={this.creditMemoOnClick}
            lnkCustomerModule={this.lnkCustomerModule}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            openDiscountPopup={this.openDiscountPopup}
            openCustomerOnOrderInq={this.openCustomerOnOrderInq}
            openCustomerTransactionsInq={this.openCustomerTransactionsInq}
            openCustomerStatisticsInq={this.openCustomerStatisticsInq}
            openCustomerSalesHistoryInq={this.openCustomerSalesHistoryInq}
            openCustomerMostRecentFabricsInq={
              this.openCustomerMostRecentFabricsInq
            }
            openCustomerCurrentAgingInq={this.openCustomerCurrentAgingInq}
            closeModalCallBack={this.closeModalCallBack}
            deleteLine={this.deleteLine}
            addDiscountAmount={this.addDiscountAmount}
            closeAlertDiscountModalCallBack={
              this.closeAlertDiscountModalCallBack
            }
            displayAutoCompleteDiscountList={
              this.displayAutoCompleteDiscountList
            }
            discountReasonEnterKeyEventHandler={
              this.discountReasonEnterKeyEventHandler
            }
            discountReasonOnChange={this.discountReasonOnChange}
            billToOnChange={this.billToOnChange}
            billToEnterKeyEventHandler={this.billToEnterKeyEventHandler}
            displayBillToAutoCompleteList={this.displayBillToAutoCompleteList}
            hideAlertCallBacklvl1={this.hideAlertCallBacklvl1}
            inputBoxonBlurCallBack={this.inputBoxonBlurCallBack}
            pfLineClick={this.pfLineClick}
            handleSortingDiscountChange={this.handleSortingDiscountChange}
            invoiceOnChange={this.invoiceOnChange}
            handleSearchInvoice={this.handleSearchInvoice}
            handleResetInvoice={this.handleResetInvoice}
          />
        )}
        <ReasonCaptureComponent
          reasons={this.state.reversalReasons}
          reasonData={this.state.reasonData}
          title="Account Receivable Reverse"
          // onChange={this.reverseReasonOnChange}
          onClick={this.reverseReasonContinue}
          isShowPopup={this.state.isShowReversalReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          onChange={this.onReasonChange}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <MessageBoxComponent
          isShowPopup={this.state.isShowWarningMsgPopup}
          warningMesage={this.state.warningMessage}
          title="Warning Message"
          onYesButtonClick={this.onYesButtonClick}
          onNoButtonClick={this.onNoButtonClick}
          closeMessageModelCallBack={this.closeMessageModelCallBack}
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowAdvanceSearchPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Advance Search"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlertlvl1}
              hideAlertCallBack={this.hideAlertCallBacklvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.onAdvanceSearchClick(e)}
              >
                Search
              </Button>
            </div>
          }
          content={
            <div className="criteria header_div ">
              <Row>
                <Col sm="2">
                  <FormLabel>AR#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="accountReceivableNumber"
                    type="text"
                    placeholder="Enter ARNumber"
                    value={criteria.accountReceivableNumber}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>AR# StartsWith</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="accountReceivableNumberStartsWith"
                    type="text"
                    placeholder="Enter AccountReceivableNumberStartsWith"
                    value={criteria.accountReceivableNumberStartsWith}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>AR# Contains</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="accountReceivableNumberContains"
                    type="text"
                    placeholder="Enter ARNumberContains"
                    value={criteria.accountReceivableNumberContains}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="customerCode"
                    placeholder="Select customer"
                    onChange={this.onAdvSearchChange}
                    value={criteria.customerCode}
                    lookupRequired={true}
                    lookupHandler={this.state.customerLookupHandler}
                    isLoading={this.state.isCustomerDataLoding}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Check#</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="checkNumber"
                    type="text"
                    placeholder="Enter check#"
                    value={criteria.checkNumber}
                    onChange={this.onAdvSearchChange}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowMailPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel3"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Mail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.sendMail(e)}
              >
                Send
              </Button>
            </div>
          }
          content={
            <GenerateMailPopup
              {...this.state}
              mailOnChange={this.mailOnChange}
            />
          }
        />
      </div>
    );
  }
}
class GenerateMailPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  mailOnChange = (e) => {
    this.props.mailOnChange(e);
  };
  render() {
    let mailInfoBean = this.props.mailInfoBean;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>From</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox value={mailInfoBean.from} disabled={true} />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>To</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="tos"
              value={mailInfoBean.tos}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>CCs</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="ccs"
              value={mailInfoBean.ccs}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>BCCs</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="bccs"
              value={mailInfoBean.bccs}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>Title</FormLabel>
          </Col>
          <Col sm="6">
            <InputTextbox
              name="title"
              value={mailInfoBean.title}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="1">
            <FormLabel>Attachments</FormLabel>
          </Col>
        </Row>
        <Row>
          <Col sm="1"></Col>
          <Col sm="6">
            <textarea
              rows={12}
              cols={72}
              name="message"
              value={mailInfoBean.message}
              onChange={this.mailOnChange}
              disabled={isDisabledFields}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
class AccountReceivableListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  listFormOnChange = (e) => {
    this.props.listFormOnChange(e);
  };
  advanceSearch = (e) => {
    if (e.detail == 1) this.props.advanceSearch();
  };
  filterAR = (e) => {
    if (e.detail == 1) this.props.filterAR();
  };
  resetFilteredAR = (e) => {
    if (e.detail == 1) this.props.resetFilteredAR();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editAccountReceivable = (e, val, rowData) => {
    if (e.detail == 1) this.props.editAccountReceivable(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterAR();
    }
  };
  render() {
    let accountreceivable_list = [];
    accountreceivable_list = this.props.accountreceivable_list;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="accountReceivableNumberContains"
                type="text"
                value={criteria.accountReceivableNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>

            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filterAR(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilteredAR(e)}>
              Reset
            </Button>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.listFormOnChange}
                name="accountReceivableStatus"
                value={criteria.accountReceivableStatus}
              >
                <option value={""}>All</option>
                <option value={"O"}>Open</option>
                <option value={"F"}>Finished</option>
                <option value={"R"}>Reversed</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                ref={this.searchRef}
                name="accountReceivableNumber"
                type="text"
                value={criteria.accountReceivableNumber}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterAR(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetFilteredAR(e)}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  AR#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerCode")}
                >
                  CustomerCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerName")}
                >
                  CustomerName
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "accountReceivableDate")
                  }
                >
                  ARDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "accountReceivableDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerCurrencyCode")
                  }
                >
                  Currency
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCurrencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "checkAmount")}>
                  CheckAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "checkAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "cardAmount")}>
                  CardAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "cardAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "cashAmount")}>
                  CashAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "cashAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "wireTransferAmount")
                  }
                >
                  WireAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "wireTransferAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "autoClearingHouseAmount")
                  }
                >
                  AChAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "autoClearingHouseAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "totalReceivedAmount")
                  }
                >
                  Tot Recd Amt
                  {this.props.order === "desc" &&
                  this.props.sortField === "totalReceivedAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "accountReceivableStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "accountReceivableStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {accountreceivable_list != null ? (
              <tbody>
                {accountreceivable_list.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editAccountReceivable(e, ln.code)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.customerCode}</td>
                    <td>{ln.customerName}</td>
                    <td>
                      {ModuleUtils.getDateFormat_v1(ln.accountReceivableDate)}
                    </td>
                    <td>{ln.customerCurrencyCode}</td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.checkAmount)}
                    </td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.cardAmount)}
                    </td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.cashAmount)}
                    </td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.wireTransferAmount)}
                    </td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.autoClearingHouseAmount)}
                    </td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.totalReceivedAmount)}
                    </td>
                    <td>
                      {ModuleUtils.getARStatusCaption(
                        ln.accountReceivableStatus,
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {accountreceivable_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class AccountReceivableEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.setInputFocus();
  }
  componentDidUpdate() {}
  setInputFocus() {
    if (this.customerCodeRef.current != null) {
      this.customerCodeRef.current.focus();
    }
  }
  inputBoxonBlurCallBack = (e, rowData) => {
    this.props.inputBoxonBlurCallBack(e, rowData);
  };
  invColumnDefinitions = () => {
    let columnList = [];
    let disableARFormFields = this.props.disableARFormFields;
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          " ",
          "selectedFlag",
          0,
          false,
          null,
          false,
          null,
          "5%", //min-width
          "5%",
        )
        .setEditableDetails(
          false, //enable input box
          "selectedFlag", //input box target name
          null,
          false,
          null,
          true,
          this.invoiceLineClick,
        )
        .setDisabled(disableARFormFields),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Invoice#",
        "invoiceNumber",
        0,
        true,
        this.invoiceOnClick,
        false,
        null,
        "10%", //min-width,
        "10%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "PF",
          "isPaymentReceivedFlag",
          0,
          false,
          null,
          false,
          null,
          "5%", //min-width,
          "5%",
        )
        .setEditableDetails(
          false, //enable input box
          "isPaymentReceivedFlag", //input box target name
          null,
          false,
          null,
          true,
          this.pfLineClick,
        )
        .setDisabled(disableARFormFields),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Date",
        "invoiceDate",
        0,
        false,
        null,
        false,
        null,
        "10%",
        "10%",
        true,
        ModuleUtils.getDateFormat_v1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CustPO#",
        "customerPurchaseOrderNumber",
        0,
        false,
        null,
        false,
        null,
        "10%", //min-width
        "10%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "TotAmt",
        "grantTotalAmount",
        1, //value alignment
        false, //enabl hyperLink value
        null, // hyperlink call back
        false, //enable image
        null, //image link call back
        "10%", //min-width
        "15%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PaidAmt",
        "postedPaidAmount",
        1, //value alignment
        false, //enabl hyperLink value
        null, // hyperlink call back
        false, //enable image
        null, //image link call back
        "10%", //min-width
        "15%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "TotalDue",
        "openInvoiceAmount",
        1, //value alignment
        false, //enabl hyperLink value
        null, // hyperlink call back
        false, //enable image
        null, //image link call back
        "10%", //min-width
        "15%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "AppliedAmt",
          "totalAppliedAmount",
          1, //value alignment
          false, //enabl hyperLink value
          null, // hyperlink call back
          false, //enable image
          null, //image link call back
          // "9em", //min-width
          // "8%" //max-width
          "160px", //min-width,
          "200px",
        )
        .setEditableDetails(
          true, //enable input box
          "totalAppliedAmount", //input box target name
          this.onAppliedAmountChange, //call Input change callback)
          false,
          null,
          false,
          null,
          this.inputBoxonBlurCallBack,
        )
        .setDisabled(disableARFormFields),
    );
    return columnList;
  };
  cmColumnDefinitions = () => {
    let columnList = [];
    let disableARFormFields = this.props.disableARFormFields;
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          " ",
          "selectedFlag",
          0,
          false,
          null,
          false,
          null,
          "5%", //min-width
          "5%",
          // "5em", //min-width
          // "5%" //max-width
        )
        .setEditableDetails(
          false, //enable input box
          "selectedFlag", //input box target name
          null,
          false,
          null,
          true,
          this.creditMemoLineClick,
        )
        .setDisabled(disableARFormFields),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Date",
        "invoiceDate",
        0,
        false,
        null,
        false,
        null,
        "10%",
        "10%",
        true,
        ModuleUtils.getDateFormat_v1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CM#",
        "invoiceNumber",
        0,
        true,

        this.creditMemoOnClick,
        false,
        null,
        null,
        "10%", //min-width,
        "10%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Desc",
        "customerPurchaseOrderNumber",
        0,
        false,
        null,
        false,
        null,
        null,
        "10%", //min-width,
        "10%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "TotalAmt",
        "grantTotalAmount",
        1, //value alignment
        false, //enabl hyperLink value
        null, // hyperlink call back
        false, //enable image
        null, //image link call back
        "10%", //min-width
        "15%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PaidAmt",
        "postedPaidAmount",
        1, //value alignment
        false, //enabl hyperLink value
        null, // hyperlink call back
        false, //enable image
        null, //image link call back
        "10%", //min-width
        "15%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "TotalDue",
        "openInvoiceAmount",
        1, //value alignment
        false, //enabl hyperLink value
        null, // hyperlink call back
        false, //enable image
        null, //image link call back
        "10%", //min-width
        "15%",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "AppAmt",
          "creditMemoAppliedAmount",
          1, //value alignment
          false, //enabl hyperLink value
          null, // hyperlink call back
          false, //enable image
          null, //image link call back
          "150px", //min-width
          "190px", //max-width
        )
        .setEditableDetails(
          true, //enable input box
          "creditMemoAppliedAmount", //input box target name
          this.onAppliedAmountChange, //call Input change callback)
          false,
          null,
          false,
          null,
          this.inputBoxonBlurCallBack,
        )
        .setDisabled(disableARFormFields),
    );
    return columnList;
  };
  // invColumnDefinitions = () => {
  //   let columnList = [];
  //   let disableARFormFields = this.props.disableARFormFields;
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(" ", "selectedFlag", 0, false, null, false, null)
  //       .setEditableDetails(
  //         false, //enable input box
  //         "selectedFlag", //input box target name
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.invoiceLineClick
  //       )
  //       .setDisabled(disableARFormFields)
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Invoice#",
  //       "invoiceNumber",
  //       0,
  //       true,

  //       this.invoiceOnClick
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails("PF", "isPaymentReceivedFlag", 0, false, null, false, null)
  //       .setEditableDetails(
  //         false, //enable input box
  //         "isPaymentReceivedFlag", //input box target name
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.pfLineClick
  //       )
  //       .setDisabled(disableARFormFields)
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Date",
  //       "invoiceDate",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       "105px",
  //       "120px"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Cus PO#",
  //       "customerPurchaseOrderNumber",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "TotAmt",
  //       "grantTotalAmount",
  //       1, //value alignment
  //       false, //enabl hyperLink value
  //       null, // hyperlink call back
  //       false, //enable image
  //       null //image link call back
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PaidAmt",
  //       "postedPaidAmount",
  //       1, //value alignment
  //       false, //enabl hyperLink value
  //       null, // hyperlink call back
  //       false, //enable image
  //       null //image link call back
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "TotalDue",
  //       "openInvoiceAmount",
  //       1, //value alignment
  //       false, //enabl hyperLink value
  //       null, // hyperlink call back
  //       false, //enable image
  //       null //image link call back
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "AppliedAmt",
  //         "totalAppliedAmount",
  //         1, //value alignment
  //         false, //enabl hyperLink value
  //         null, // hyperlink call back
  //         false, //enable image
  //         null, //image link call back
  //         "9em", //min-width
  //         "8%" //max-width
  //       )
  //       .setEditableDetails(
  //         true, //enable input box
  //         "totalAppliedAmount", //input box target name
  //         this.onAppliedAmountChange, //call Input change callback)
  //         false,
  //         null,
  //         false,
  //         null,
  //         this.inputBoxonBlurCallBack
  //       )
  //       .setDisabled(disableARFormFields)
  //   );
  //   return columnList;
  // };
  // cmColumnDefinitions = () => {
  //   let columnList = [];
  //   let disableARFormFields = this.props.disableARFormFields;
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         " ",
  //         "selectedFlag",
  //         0,
  //         false,
  //         null,
  //         false,
  //         null
  //         // "5em", //min-width
  //         // "5%" //max-width
  //       )
  //       .setEditableDetails(
  //         false, //enable input box
  //         "selectedFlag", //input box target name
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.creditMemoLineClick
  //       )
  //       .setDisabled(disableARFormFields)
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Date",
  //       "invoiceDate",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       "8%", //min-width
  //       "12%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "CM#",
  //       "invoiceNumber",
  //       0,
  //       true,

  //       this.creditMemoOnClick,
  //       false,
  //       null,
  //       "12%", //min-width
  //       "14%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "Desc",
  //       "customerPurchaseOrderNumber",
  //       0,
  //       false,
  //       null,
  //       false,
  //       null,
  //       "13%", //min-width
  //       "15%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "TotalAmt",
  //       "grantTotalAmount",
  //       1, //value alignment
  //       false, //enabl hyperLink value
  //       null, // hyperlink call back
  //       false, //enable image
  //       null, //image link call back
  //       "15%", //min-width
  //       "18%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PaidAmt",
  //       "postedPaidAmount",
  //       1, //value alignment
  //       false, //enabl hyperLink value
  //       null, // hyperlink call back
  //       false, //enable image
  //       null, //image link call back
  //       "12%", //min-width
  //       "14%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "TotalDue",
  //       "openInvoiceAmount",
  //       1, //value alignment
  //       false, //enabl hyperLink value
  //       null, // hyperlink call back
  //       false, //enable image
  //       null, //image link call back
  //       "12%", //min-width
  //       "14%" //max-width
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails(
  //         "AppAmt",
  //         "creditMemoAppliedAmount",
  //         1, //value alignment
  //         false, //enabl hyperLink value
  //         null, // hyperlink call back
  //         false, //enable image
  //         null, //image link call back
  //         "12%", //min-width
  //         "14%" //max-width
  //       )
  //       .setEditableDetails(
  //         true, //enable input box
  //         "creditMemoAppliedAmount", //input box target name
  //         this.onAppliedAmountChange, //call Input change callback)
  //         false,
  //         null,
  //         false,
  //         null,
  //         this.inputBoxonBlurCallBack
  //       )
  //       .setDisabled(disableARFormFields)
  //   );
  //   return columnList;
  // };
  closeEntryForm() {
    this.props.closeEntryForm();
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  customerCodeOnChange = (e) => {
    this.props.customerCodeOnChange(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  paymentTypeOnChange = (e) => {
    this.props.paymentTypeOnChange(e);
  };
  paymentTypeEnterKeyEventHandler = (e) => {
    this.props.paymentTypeEnterKeyEventHandler(e);
  };
  displayAutoCompletePaymentTermList = (showAutoCompleteList) => {
    this.props.displayAutoCompletePaymentTermList(showAutoCompleteList);
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.props.displayAutoCustomerCompleteList(showAutoCompleteList);
  };
  handleCustomerAutocompleteSearch = (searchString) => {
    this.props.handleCustomerAutocompleteSearch(searchString);
  };
  showHideSecondHeader = (e) => {
    if (e.detail == 1) this.props.showHideSecondHeader();
  };
  arOnChange = (e) => {
    this.props.arOnChange(e);
  };
  tenderAmountOnBlur = (e) => {
    this.props.arOnChange(e);
  };
  cardDetailsOnChange = (e) => {
    this.props.cardDetailsOnChange(e);
  };
  checkDetailsOnChange = (e) => {
    this.props.checkDetailsOnChange(e);
  };
  wireDetailsOnChange = (e) => {
    this.props.wireDetailsOnChange(e);
  };
  achDetailsOnChange = (e) => {
    this.props.achDetailsOnChange(e);
  };
  invoiceLineClick = (e, rowData) => {
    this.props.invoiceLineSelected(e, rowData);
  };
  pfLineClick = (e, rowData) => {
    this.props.pfLineClick(e, rowData);
  };
  creditMemoLineClick = (e, rowData) => {
    this.props.creditMemoLineSelected(e, rowData);
  };
  onAppliedAmountChange = (e, rowData) => {
    this.props.onAppliedAmountChange(e, rowData);
  };
  resetAppliedAmountClick = (e) => {
    if (e.detail == 1) this.props.resetAppliedAmountClick(e);
  };
  autoApplyClick = (e) => {
    if (e.detail == 1) this.props.autoApplyClick(e);
  };
  autoCalculateClick = (e) => {
    if (e.detail == 1) this.props.autoCalculateClick(e);
  };
  discountLineOnChange = (e) => {
    this.props.discountLineOnChange(e);
  };
  addorUpdateDiscountLine = (discountLine) => {
    this.props.addorUpdateDiscountLine(discountLine);
  };
  clearLines = () => {
    this.props.clearLines();
  };
  handleDiscountLineNumberClick = (data) => {
    this.props.handleDiscountLineNumberClick(data);
  };
  invoiceOnClick = (rowData) => {
    this.props.invoiceOnClick(rowData);
  };
  creditMemoOnClick = (rowData) => {
    this.props.creditMemoOnClick(rowData);
  };
  lnkCustomerModule = (e) => {
    if (e.detail == 1) this.props.lnkCustomerModule(e);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.props.hideAlertCallBack(msgType, isDisplayed);
  };
  openDiscountPopup = (e) => {
    if (e.detail == 1) this.props.openDiscountPopup();
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
  };
  openCustomerOnOrderInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerOnOrderInq(code);
  };
  openCustomerTransactionsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerTransactionsInq(code);
  };
  openCustomerStatisticsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerStatisticsInq(code);
  };
  openCustomerSalesHistoryInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerSalesHistoryInq(code);
  };
  openCustomerMostRecentFabricsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerMostRecentFabricsInq(code);
  };
  openCustomerCurrentAgingInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerCurrentAgingInq(code);
  };
  closeModalCallBack = (isOpen) => {
    this.props.closeModalCallBack(isOpen);
  };
  deleteLine = (rowData) => {
    this.props.deleteLine(rowData);
  };
  addDiscountAmount = (e) => {
    if (e.detail == 1) this.props.addDiscountAmount();
  };
  displayAutoCompleteDiscountList = (list) => {
    this.props.displayAutoCompleteDiscountList(list);
  };
  discountReasonEnterKeyEventHandler = (e) => {
    this.props.discountReasonEnterKeyEventHandler(e);
  };
  discountReasonOnChange = (e) => {
    this.props.discountReasonOnChange(e);
  };
  billToOnChange = (e) => {
    this.props.billToOnChange(e);
  };
  billToEnterKeyEventHandler = (e) => {
    this.props.billToEnterKeyEventHandler(e);
  };
  displayBillToAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayBillToAutoCompleteList(showAutoCompleteList);
  };
  render() {
    let invoiceLines = [];
    if (!isEmptyArray(this.props.invLines)) invoiceLines = this.props.invLines;
    let crediMemoLines = [];
    if (!isEmptyArray(this.props.crediMemoLines))
      crediMemoLines = this.props.crediMemoLines;
    let arData = null;
    let customer_list = [];
    if (!isEmptyArray(this.props.customer_list))
      customer_list = this.props.customer_list;
    let disableARFormFields = this.props.disableARFormFields;
    arData = this.props.arData;
    /* tender amount calculation */
    let tenderAmount =
      parseFloat(arData.cashAmount) +
      parseFloat(arData.checkAmount) +
      parseFloat(arData.cardAmount) +
      parseFloat(arData.wireTransferAmount) +
      parseFloat(arData.autoClearingHouseAmount);
    if (isNaN(tenderAmount)) {
      tenderAmount = 0;
    }
    let invLines = [];
    let cmLines = [];
    let totalAppliedAmount = 0;
    let appliedAmount = 0;
    let creditMemoAppliedAmount = 0;
    let totalDue = 0;
    let openInvoiceAmt = 0;
    let availabeToApply = 0;
    /* totalAppliedAmount and appliedAmount calculation */
    if (!isEmptyArray(arData.lines))
      arData.lines.map((line) => {
        if (!line.creditMemoFlag) {
          invLines.push(line);
          /* Total Due Calculation*/
          // console.log("line.openInvoiceAmount *", line.openInvoiceAmount);
          totalDue += parseFloat(line.openInvoiceAmount);
          if (line.selectedFlag) {
            openInvoiceAmt += parseFloat(line.openInvoiceAmount);
          }
        } else if (line.creditMemoFlag) {
          cmLines.push(line);
          creditMemoAppliedAmount += parseFloat(line.creditMemoAppliedAmount);
          totalDue += parseFloat(line.openInvoiceAmount);
        }
        // console.log("linetotalDue after*", totalDue);
        if (line.isFetched) {
          appliedAmount +=
            parseFloat(line.totalAppliedAmount) +
            parseFloat(line.creditMemoAppliedAmount);
          // totalAppliedAmount = parseFloat(appliedAmount);
        } else {
          appliedAmount += parseFloat(line.totalAppliedAmount);
          // totalAppliedAmount = parseFloat(appliedAmount);
        }
      });
    if (
      arData.appliedCreditMemoLines != null ||
      !isEmptyArray(arData.appliedCreditMemoLines)
    ) {
      arData.appliedCreditMemoLines.map((ln) => {
        // totalDue -= parseFloat(ln.openInvoiceAmount);
        totalDue -= parseFloat(ln.creditMemoAppliedAmount);
        // totalDue -= parseFloat(ln.creditMemoAmount);
      });
    }
    /* availabeToApply Calculation */
    //let availabeToApply = 0;
    if (this.props.isAutoApply) {
      availabeToApply =
        parseFloat(arData.discountAmount) - parseFloat(creditMemoAppliedAmount);
    } else if (this.props.isAutoCalculate) {
      availabeToApply = 0;
      if (
        arData.appliedCreditMemoLines != null ||
        !isEmptyString(arData.appliedCreditMemoLines)
      ) {
        arData.appliedCreditMemoLines.map((ln) => {
          appliedAmount -= parseFloat(ln.creditMemoAppliedAmount);
        });
      }
    } else {
      availabeToApply =
        parseFloat(tenderAmount) +
        -parseFloat(creditMemoAppliedAmount) -
        parseFloat(appliedAmount) +
        parseFloat(arData.discountAmount);
    }
    let checkDetail = this.props.checkDetail;
    let cardDetail = this.props.cardDetail;
    let wireDetail = this.props.wireDetail;
    let achDetail = this.props.achDetail;
    let isDisabledFields = this.props.isDisabledFields;

    const textAreaStyle = {
      height: "3em",
      width: "25em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    const invoiceLineStyles = {
      table: {
        style: {
          height: "400px",
          width: "100%",
          ScrollX: false,
          overflow: "auto",
          fontFamily: "Arial, Helvetica, sans-serif",
          fontSize: "80%",
          borderCollapse: "collapse",
          verticalAlign: "middle !important",
          padding: "5px",
        },
      },
      header: {
        style: {
          display: "none",
          textAlign: "center",
        },
      },
      cells: {
        style: {
          paddingTop: "5px",
          paddingBottom: "5px",
          // "&:not(:last-of-type)": {
          borderStyle: "solid",
          borderWidth: "0.5px",
          borderColor: "#fff",
          paddingLeft: "0",
          paddingRight: "0",
          // },
        },
      },
      // cells: {
      //   style: {
      //     // paddingTop: "5px",
      //     // paddingBottom: "5px",
      //     padding: "5px",
      //     borderRight: "2px solid #fff",
      //   },
      // },
      rows: {
        style: {
          minHeight: "20px",
        },
        denseStyle: {
          minHeight: "0px",
        },
        highlightOnHoverStyle: {
          backgroundColor: "#ddd",
          color: "#000",
        },
        stripedStyle: {
          color: "#000",
          backgroundColor: "#e9ecef",
        },
      },
      button: {
        default: "#5482AE",
      },
      headRow: {
        style: {
          backgroundColor: "#655f80",
          // paddingTop: "2px",
          // paddingBottom: "2px",
          minHeight: "2rem",
          // borderBottomWidth: "1px",
          // borderBottomColor: "#fff",
          // borderBottomStyle: "2px solid #fff",
        },
      },
      headCells: {
        style: {
          color: "#fff",
          paddingRight: "1px",
          paddingLeft: "1px",
          borderRight: "2px solid #fff",
          textAlign: "center",
        },
        activeSortStyle: {
          color: "#fff",
          "&:focus": {
            outline: "none",
          },
          "&:hover:not(:focus)": {
            color: "#fff",
          },
          textAlign: "center",
        },
        inactiveSortStyle: {
          "&:focus": {
            outline: "none",
            color: "#fff",
          },
          "&:hover": {
            color: "#fff",
          },
          textAlign: "center",
        },
      },
    };
    var button = {
      alignContent: "center",
      width: "100%",
    };
    // const creditMemoLineStyles = {
    //   table: {
    //     style: {
    //       height: "15em",
    //       width: "100%",
    //     },
    //   },
    //   headRow: {
    //     style: {},
    //     denseStyle: {},
    //   },
    //   rows: {
    //     style: {
    //       overflow: "auto",
    //     },
    //   },
    //   headCells: {
    //     style: {
    //       fontSize: "12px",
    //       fontWeight: "600",
    //       paddingLeft: "1px",
    //       paddingRight: "1px",
    //       color: "rgb(76, 83, 71)",
    //     },
    //   },
    //   cells: {
    //     style: {
    //       fontSize: "13px",
    //       wordBreak: "break-word",
    //       width: "100%",
    //       borderColor: "#ebe2e27d",
    //       borderBottomWidth: "1px",
    //       borderBottomStyle: "solid",
    //     },
    //   },
    // };
    const is3PL = this.props.is3PL;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.props.isShowCMModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.props.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerOnOrderInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerTransactionsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerStatisticsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerSalesHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerMostRecentFabricsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isCustomerCurrentAgingInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <div className="header_div col-md-12 col-lg-12">
          <div>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>AR Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  onChange={this.onChange}
                  name="accountReceivableDate"
                  value={arData.accountReceivableDate}
                  disabled={disableARFormFields}
                  isMandatory={true}
                ></DatePickerComponent_adv>
              </Col>
              <Col className="so-align-items-left" sm="1">
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkCustomerModule(e)}
                >
                  Customer
                </FormLabel>{" "}
                <Col>
                  {arData.customerCode != "" &&
                  arData.customerCode != NEW_ENTRY &&
                  arData.customerCode != undefined ? (
                    <ShortCutMenuPopup
                      value={arData.customerCode}
                      menuItems={
                        <ul>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerOnOrderInq(
                                e,
                                arData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer On-Order{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerTransactionsInq(
                                e,
                                arData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Transactions{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerStatisticsInq(
                                e,
                                arData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Statistics{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerSalesHistoryInq(
                                e,
                                arData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Sales History{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerMostRecentFabricsInq(
                                e,
                                arData.customerCode,
                              )
                            }
                          >
                            {is3PL
                              ? "Customer Most Recent Items"
                              : "Customer Most Recent Fabrics"}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerCurrentAgingInq(
                                e,
                                arData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Current Aging{" "}
                          </li>
                        </ul>
                      }
                    />
                  ) : null}
                </Col>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.customerCodeOnChange}
                  ref={this.customerCodeRef}
                  name="customerCode"
                  placeholder="customerCode"
                  value={arData.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.props.customerLookupHandler}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCustomerCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteCustomerList
                  }
                  disabled={disableARFormFields}
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="customerName"
                  onChange={this.onChange}
                  value={this.props.arData.customerName}
                  disabled={true}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Bill to</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.billToOnChange}
                  placeholder="billToCode"
                  name="billToCode"
                  value={arData.billToCode}
                  lookupRequired={this.props.isShowLookup}
                  lookupHandler={this.props.BillToLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.billToEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.billToPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayBillToAutoCompleteList}
                  showAutoCompleteList={this.props.isShowAutoCompleteBillToList}
                  disabled={disableARFormFields}
                  isMandatory={true}
                />
              </Col>
              {/* <Col sm="1">
                <CollapseComponent
                  isOpen={this.props.isCollapsible_open}
                  onClick={(e) => this.showHideSecondHeader(e)}
                />
              </Col> */}
            </Row>
            {/* <Row></Row> */}
            {/* <Row>

              </Row> */}
            {/* <Row></Row> */}
          </div>
          <div
            className="header_secondary_div"
            style={this.props.isCollapsible_open ? {} : { display: "none" }}
          >
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Currency</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="customerCurrencyCode"
                  onChange={this.onChange}
                  value={arData.customerCurrencyCode}
                  disabled={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Payment Type</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.paymentTypeOnChange}
                  name="paymentTypeCode"
                  placeholder="PaymentType"
                  value={arData.paymentTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.props.paymentTypeLookupHandler}
                  enterKeyEventHandler={this.paymentTypeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.paymentTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePaymentTermList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompletePaymentTypeList
                  }
                  readOnly={disableARFormFields}
                  disabled={disableARFormFields}
                  isNotFound={this.props.isNotFound}
                ></InputTextbox>
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>OverPaidCM</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="overPaymentCreditMemoNumber"
                  onChange={this.onChange}
                  value={arData.overPaymentCreditMemoNumber}
                  readOnly={disableARFormFields}
                  disabled={disableARFormFields}
                />
              </Col>
            </Row>
            <div className="div_inline div_Custom_5">
              <div className="div_80_no_overflow_V1">
                <div className="div_Mini header_div">
                  {this.props.isCashPayment && (
                    <div>
                      <div className="inv_caption"> Cash Details </div>
                      {/* <div className="label_head"> Cash Details </div> */}
                      <div>
                        <Row>
                          <Col sm="1">
                            <FormLabel>Amount</FormLabel>
                          </Col>
                          <Col sm="2">
                            <NumberFormatInputbox
                              name={"cashAmount"}
                              onChange={this.arOnChange}
                              placeholder="Enter Amount"
                              value={arData.cashAmount}
                              className="text-right"
                              decimalScale={2}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col />
                          <Col />
                        </Row>
                      </div>
                    </div>
                  )}
                  {this.props.isOtherPayment && <div></div>}
                  {this.props.isCheckPayment && (
                    <div>
                      <div className="inv_caption"> Check Details </div>
                      {/* <div className="label_head"> Check Details </div> */}
                      <div className="col-md-12 col-lg-12">
                        <Row>
                          <Col sm="1">
                            <FormLabel>Check#</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="checkNumber"
                              type="text"
                              placeholder="Enter Check Number"
                              value={checkDetail.checkNumber}
                              onChange={this.checkDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>CheckDate</FormLabel>
                          </Col>
                          <Col sm="2">
                            <DatePickerComponent_adv
                              name="checkDate"
                              value={checkDetail.checkDate}
                              onChange={this.checkDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>BankName</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="issuedBankName"
                              type="text"
                              placeholder="Enter BankName"
                              value={checkDetail.issuedBankName}
                              onChange={this.checkDetailsOnChange}
                              disabled={disableARFormFields}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>CheckAmount</FormLabel>
                          </Col>
                          <Col sm="2">
                            <NumberFormatInputbox
                              name={"checkAmount"}
                              onChange={this.checkDetailsOnChange}
                              placeholder="Enter CheckAmount"
                              value={checkDetail.checkAmount}
                              className="text-right"
                              decimalScale={2}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                  {this.props.isWirePayment && (
                    <div>
                      <div className="inv_caption"> Wire Details </div>
                      {/* <div className="label_head"> Wire Details </div> */}
                      <div>
                        <Row>
                          <Col sm="1">
                            <FormLabel>WireTransfer#</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="wireTransferReferenceNumber"
                              type="text"
                              placeholder="Enter Wire Number"
                              value={wireDetail.wireTransferReferenceNumber}
                              onChange={this.wireDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>WireTransferDate</FormLabel>
                          </Col>
                          <Col sm="2">
                            <DatePickerComponent_adv
                              name="wireTransferDate"
                              value={wireDetail.wireTransferDate}
                              onChange={this.wireDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>BankName</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="issuedBankName"
                              type="text"
                              placeholder="Enter BankName"
                              value={wireDetail.issuedBankName}
                              onChange={this.wireDetailsOnChange}
                              disabled={disableARFormFields}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>WireTranfermount</FormLabel>
                          </Col>
                          <Col sm="2">
                            <NumberFormatInputbox
                              name={"wireTransferAmount"}
                              onChange={this.wireDetailsOnChange}
                              placeholder="Enter wireTransferAmount"
                              value={wireDetail.wireTransferAmount}
                              className="text-right"
                              decimalScale={2}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                  {this.props.isCardPayment && (
                    <div>
                      <div className="inv_caption"> Card Details </div>
                      {/* <div className="label_head"> Card Details </div> */}
                      <div>
                        <Row>
                          <Col sm="1">
                            <FormLabel>Card#</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="cardNumber"
                              type="text"
                              placeholder="Enter Card Number"
                              value={cardDetail.cardNumber}
                              onChange={this.cardDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>CardType</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="cardType"
                              type="text"
                              placeholder="Enter CardType"
                              value={cardDetail.cardType}
                              onChange={this.cardDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>Exp Month</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="expiryMonth"
                              type="text"
                              placeholder="Enter Expire Month"
                              value={cardDetail.expiryMonth}
                              onChange={this.cardDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>Exp Year</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="expiryYear"
                              type="text"
                              placeholder="Enter Expire Year"
                              value={cardDetail.expiryYear}
                              onChange={this.cardDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="1">
                            <FormLabel>CardAmount</FormLabel>
                          </Col>
                          <Col sm="2">
                            <NumberFormatInputbox
                              name={"cardAmount"}
                              onChange={this.cardDetailsOnChange}
                              placeholder="Enter CardAmount"
                              value={cardDetail.cardAmount}
                              className="text-right"
                              decimalScale={2}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>DebitCard</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputCheckbox
                              name="isDebitCard"
                              type="checkbox"
                              checked={cardDetail.isDebitCard}
                              onChange={this.cardDetailsOnChange}
                              disabled={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>CC Auth</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputCheckbox
                              name="isPaymentProcessRequired"
                              type="checkbox"
                              checked={cardDetail.isPaymentProcessRequired}
                              onChange={this.cardDetailsOnChange}
                              disabled={disableARFormFields}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                  {this.props.isAchPayment && (
                    <div>
                      <div className="inv_caption">
                        {/* <div className="label_head"> */} Aito Clearing House
                        Details{" "}
                      </div>
                      <div>
                        <Row>
                          <Col sm="1">
                            <FormLabel>ACH Ref#</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="autoClearingHouseReferenceNumber"
                              type="text"
                              placeholder="Enter ACH Ref Number"
                              value={achDetail.autoClearingHouseReferenceNumber}
                              onChange={this.achDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>ACH Date</FormLabel>
                          </Col>
                          <Col sm="2">
                            <DatePickerComponent_adv
                              name="autoClearingHouseDate"
                              value={achDetail.autoClearingHouseDate}
                              onChange={this.achDetailsOnChange}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>Remarks</FormLabel>
                          </Col>
                          <Col sm="2">
                            <InputTextbox
                              name="comments"
                              type="text"
                              placeholder="Enter comments"
                              value={achDetail.comments}
                              onChange={this.achDetailsOnChange}
                              disabled={disableARFormFields}
                            />
                          </Col>
                          <Col sm="1">
                            <FormLabel>ACH Amount</FormLabel>
                          </Col>
                          <Col sm="2">
                            <NumberFormatInputbox
                              name={"autoClearingHouseAmount"}
                              onChange={this.achDetailsOnChange}
                              placeholder="Enter autoClearingHouseAmount"
                              value={achDetail.autoClearingHouseAmount}
                              className="text-right"
                              decimalScale={2}
                              disabled={disableARFormFields}
                              isMandatory={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  {!disableARFormFields && (
                    <div style={button}>
                      {" "}
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.autoApplyClick(e)}
                      >
                        Auto Apply{" "}
                      </Button>
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.resetAppliedAmountClick(e)}
                      >
                        Reset Applied Amounts{" "}
                      </Button>
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.autoCalculateClick(e)}
                      >
                        Auto Calculate{" "}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
              <div className="div_20_no_overflow_v1 header_div">
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>Tot Tender Amt</FormLabel>
                  </Col>
                  <Col className="summary_text_box">
                    <NumberFormatInputbox
                      value={tenderAmount}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"tenderAmount"}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>Tot Applied Amt</FormLabel>
                  </Col>
                  <Col className="summary_text_box">
                    <NumberFormatInputbox
                      value={appliedAmount}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"appliedAmount"}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="align-items-left">
                    <FormLabel>AvailabeToApply</FormLabel>
                  </Col>
                  <Col className="summary_text_box">
                    <NumberFormatInputbox
                      value={availabeToApply}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"availabeToApply"}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="so-align-items-left">
                    <FormLabel>Discount Amt</FormLabel>{" "}
                    <Col>
                      <ShortCutMenuPopup
                        value={"Disc Info"}
                        menuItems={
                          <ul>
                            <li
                              className="shortcut-menu-item"
                              onClick={(e) => this.openDiscountPopup(e)}
                            >
                              {" "}
                              Discount Info{" "}
                            </li>
                          </ul>
                        }
                      />
                    </Col>
                  </Col>
                  <Col className="summary_text_box">
                    <NumberFormatInputbox
                      value={arData.discountAmount}
                      onChange={this.onChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"discountAmount"}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>Comments</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    type="text"
                    name="comments"
                    value={arData.comments}
                    onChange={this.onChange}
                    disabled={disableARFormFields}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Total Due</FormLabel>
                </Col>
                <Col sm="3">
                  <NumberFormatInputbox
                    name={"totalDue"}
                    value={totalDue}
                    onChange={this.onChange}
                    className="summary_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Applied Amount</FormLabel>
                </Col>
                <Col sm="3">
                  <NumberFormatInputbox
                    name={"appliedAmount"}
                    value={appliedAmount}
                    onChange={this.onChange}
                    className="summary_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>

            {!isEmptyArray(invoiceLines) &&
            arData.accountReceivableStatus != "F" ? (
              <div className="">
                <Row>
                  <Col className="align-items-left">
                    <FormLabel className="label_head">
                      Invoice Criteria
                    </FormLabel>
                  </Col>
                </Row>

                <div className="div_inline">
                  <div className="div_25_no_overflow_no_height">
                    <Row>
                      <Col sm="4" className="text-start">
                        <FormLabel>Invoice</FormLabel>
                      </Col>
                      <Col sm="8">
                        <InputTextbox
                          name="invoiceNumber"
                          value={this.props.invoiceCriteria.invoiceNumber}
                          onChange={this.props.invoiceOnChange}
                          isMandatory={true}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="div_20_no_overflow">
                    <Row>
                      <Col sm="2">
                        <Button
                          size="sm"
                          onClick={this.props.handleSearchInvoice}
                        >
                          Search
                        </Button>
                      </Col>

                      <Col sm="2">
                        <Button
                          size="sm"
                          onClick={this.props.handleResetInvoice}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        <div className="div_inline">
          {/* <div className="div_Equal_no_overflow"> */}
          <div className="div_60_no_overflow_1">
            <Row>
              <Col className="align-items-left" sm="">
                <FormLabel className="label_head">Invoice Lines</FormLabel>
              </Col>
            </Row>

            <EditableDataGrid_v1
              columnsList={this.invColumnDefinitions()}
              dataList={invoiceLines}
              customStyles={invoiceLineStyles}
              fixedHeader={true}
            />
          </div>
          {/* <div className="div_Equal_no_overflow"> */}
          <div className="div_60_no_overflow_1">
            <Row>
              <Col className="align-items-left" sm="">
                <FormLabel className="label_head">CreditMemo Lines</FormLabel>
              </Col>
            </Row>

            <EditableDataGrid_v1
              columnsList={this.cmColumnDefinitions()}
              // dataList={cmLines}
              dataList={crediMemoLines}
              customStyles={invoiceLineStyles}
              fixedHeader={true}
            />
          </div>
        </div>
        {/* <div className="div_inline">
          <div className="div_Equal_no_overflow">
            <EditableDataGrid
              columnsList={this.invColumnDefinitions()}
              // dataList={invLines}
              dataList={invoiceLines}
              // customStyles={invoiceLineStyles}
              fixedHeader={true}
            />
          </div>
          <div className="div_Equal_no_overflow">
            <EditableDataGrid
              columnsList={this.cmColumnDefinitions()}
              // dataList={cmLines}
              dataList={crediMemoLines}
              // customStyles={creditMemoLineStyles}
              fixedHeader={true}
            />
          </div>
        </div> */}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.props.isShowDiscountPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.props.closeAlertDiscountModalCallBack}
          title={"Discount Details"}
          closeOnDocumentClick={false}
          popupLvlClass={"popupSizeLevel1"}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowPopupAlertlvl1}
              hideAlertCallBack={this.props.hideAlertCallBacklvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.addDiscountAmount(e)}
                disabled={this.props.isDisableFields}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <AccountReceivableDiscountPopup
              {...this.state}
              isDisableFields={this.props.isDisableFields}
              arData={this.props.arData}
              discountReasons={this.props.discountReasons}
              discountDetail={this.props.discountDetail}
              disableARFormFields={this.props.disableARFormFields}
              discountReasonLookupHandler={
                this.props.discountReasonLookupHandler
              }
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              clearLines={this.clearLines}
              handleDiscountLineNumberClick={this.handleDiscountLineNumberClick}
              addorUpdateDiscountLine={this.addorUpdateDiscountLine}
              discountLineOnChange={this.discountLineOnChange}
              deleteLine={this.deleteLine}
              readLines={this.readLines}
              discountList={this.props.discountList}
              displayAutoCompleteDiscountList={
                this.displayAutoCompleteDiscountList
              }
              discountReasonEnterKeyEventHandler={
                this.discountReasonEnterKeyEventHandler
              }
              discountReasonOnChange={this.discountReasonOnChange}
              showAutoCompleteDiscountList={
                this.props.showAutoCompleteDiscountList
              }
              discountPageListForAutoCompleteList={
                this.props.discountPageListForAutoCompleteList
              }
              handleSortingDiscountChange={
                this.props.handleSortingDiscountChange
              }
            />
          }
        />
      </div>
    );
  }
}
class AccountReceivableHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  DateGridColumnStatusDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Date",
        "createdDate",
        0,
        false,
        null,
        false,
        null,
        "80px",
        "140px", //max-width
        true,
        ModuleUtils.getDateFormat_v1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Status", "currentStatus"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PreviousStatus",
        "previousStatus",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("DoneBy", "createdBy"),
    );
    return columnList;
  };
  handleSortingHistoryChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingHistoryChange(accessor);
  };
  render() {
    let arData = this.props.arData;
    let statusTrackList = this.props.statusTrackList;
    let statusTracks = new Array();
    if (statusTrackList != null) {
      statusTracks = statusTrackList;
    }
    // statusTracks = arData.statusTracks;
    return (
      <div className="header_div">
        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingHistoryChange(e, "createdDate")
                  }
                >
                  Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingHistoryChange(e, "currentStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingHistoryChange(e, "code")}>
                  PreviousStatus
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingHistoryChange(e, "createdBy")
                  }
                >
                  DoneBy
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {statusTracks != null ? (
              <tbody>
                {statusTracks.map((ln, index) => (
                  <tr key={index}>
                    <td>{ln.createdDate}</td>
                    <td>{ModuleUtils.getARStatusCaption(ln.currentStatus)}</td>
                    <td>{ModuleUtils.getARStatusCaption(ln.previousStatus)}</td>
                    <td>{ln.createdBy}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {statusTracks.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class AccountReceivableDiscountPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      //
    };
  }
  componentDidMount() {}

  deleteLine = (e, val, rowData) => {
    if (e.detail == 1) this.props.deleteLine(rowData);
  };
  readLines = (e, rowData) => {
    this.props.readLines(rowData);
  };
  handleDiscountLineNumberClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.handleDiscountLineNumberClick(rowData);
  };
  clearLines = (e) => {
    if (e.detail == 1) this.props.clearLines();
  };
  addDiscountLines = (e) => {
    if (e.detail == 1)
      this.props.addorUpdateDiscountLine(this.props.discountDetail);
  };
  discountLineOnChange = (e) => {
    this.props.discountLineOnChange(e);
  };
  discountReasonOnChange = (e) => {
    this.props.discountReasonOnChange(e);
  };
  discountReasonEnterKeyEventHandler = (e) => {
    this.props.discountReasonEnterKeyEventHandler(e);
  };
  displayAutoCompleteDiscountList = (list) => {
    this.props.displayAutoCompleteDiscountList(list);
  };
  handleSortingDiscountChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingDiscountChange(accessor);
  };

  render() {
    let arData = this.props.arData;
    let discountDetail = this.props.discountDetail;
    let disableARFormFields = this.props.disableARFormFields;
    let lineDatas = [];
    let isDisableFields = this.props.isDisableFields;
    if (!isEmptyArray(this.props.discountList)) {
      lineDatas = this.props.discountList;
    }

    const textAreaStyle = {
      maxHeight: "75px",
      minHeight: "4em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <Row className="header_div">
          <Col className="align-items-left" sm="1">
            {" "}
            <FormLabel>CompanyCode</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="companyCode"
              isMandatory={true}
              onChange={this.discountLineOnChange}
              value={arData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col className="align-items-left" sm="1">
            {" "}
            <FormLabel>AR#</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="code"
              isMandatory={true}
              onChange={this.discountLineOnChange}
              value={arData.code}
              disabled={true}
            />{" "}
          </Col>
        </Row>

        <Row>
          <Col className="align-items-left" sm="2">
            <FormLabel className="label_head">Discount Details</FormLabel>
          </Col>
        </Row>
        <Row className="header_div">
          <Col sm="12">
            <div className="div_Custom_1">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingDiscountChange(e, "lineNumber")
                      }
                    >
                      Line#
                      {this.props.order === "desc" &&
                      this.props.sortField === "lineNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDiscountChange(
                          e,
                          "discountDetailReasonCode",
                        )
                      }
                    >
                      Reason
                      {this.props.order === "desc" &&
                      this.props.sortField === "discountDetailReasonCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDiscountChange(
                          e,
                          "discountDetailReasonName",
                        )
                      }
                    >
                      Description
                      {this.props.order === "desc" &&
                      this.props.sortField === "discountDetailReasonName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingDiscountChange(e, "discountAmount")
                      }
                    >
                      Amount
                      {this.props.order === "desc" &&
                      this.props.sortField === "discountAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                {lineDatas != null ? (
                  <tbody>
                    {lineDatas.map((ln, index) => (
                      <tr key={index}>
                        <td className="hyperLinkText">
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.handleDiscountLineNumberClick(
                                e,
                                ln.lineNumber,
                                ln,
                              )
                            }
                          >
                            {ln.lineNumber}
                          </Button>
                        </td>
                        <td>{ln.discountDetailReasonCode}</td>
                        <td>{ln.discountDetailReasonName}</td>
                        <td className="text-end">{ln.discountAmount}</td>
                        <td>
                          {!isDisableFields && (
                            <Button
                              size="sm"
                              onClick={(e) =>
                                this.deleteLine(e, ln.lineNumber, ln)
                              }
                            >
                              <DeleteIcon />
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
              {lineDatas.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="align-items-left" sm="1">
            <FormLabel className="label_head">LineDetail</FormLabel>
          </Col>
        </Row>

        <div className="header_div">
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Ln#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                type="text"
                onChange={this.discountLineOnChange}
                readOnly={true}
                value={discountDetail.lineNumber}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Reason</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="discountDetailReasonCode"
                placeholder="Enter discountDetailReasonCode"
                onChange={this.discountReasonOnChange}
                value={discountDetail.discountDetailReasonCode}
                lookupHandler={this.props.discountReasonLookupHandler}
                lookupRequired={true}
                valuePropery="code"
                descriptionProperty="description"
                enterKeyEventHandler={this.discountReasonEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.discountPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteDiscountList}
                showAutoCompleteList={this.props.showAutoCompleteDiscountList}
                disabled={isDisableFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Discount</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={discountDetail.discountAmount}
                onChange={this.discountLineOnChange}
                className=" text-right"
                decimalScale={2}
                name={"discountAmount"}
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
            <Col>
              <Button
                size="sm"
                id="fabric_Add_Button"
                className="header_buttons enterFocus"
                onClick={(e) => this.addDiscountLines(e)}
                disabled={isDisableFields}
              >
                Add/Update
              </Button>
              <Button
                id="fabric_Add_Button"
                className="header_buttons"
                size="sm"
                onClick={(e) => this.clearLines(e)}
                disabled={isDisableFields}
              >
                Clear
              </Button>
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel> Description</FormLabel>
            </Col>

            <Col sm="5">
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="discountDetailReasonName"
                type="text"
                onChange={this.discountLineOnChange}
                value={discountDetail.discountDetailReasonName}
                disabled={isDisableFields}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
function AccountReceivableModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <AccountReceivableList {...props} name="" /> <br />
    </div>
  );
}
export default AccountReceivableModule;
